// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import moment from 'moment';
// import * as XLSX from 'xlsx';
// import { saveAs } from 'file-saver';

// const ExpenseReport = () => {
//     const [expenses, setExpenses] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [filters, setFilters] = useState({
//         dateRange: 'this_month',
//         project: '',
//         vendor: '',
//         client: '',
//         category: ''
//     });
//     const [filterOptions, setFilterOptions] = useState({
//         projects: [],
//         vendors: [],
//         clients: [],
//         categories: []
//     });
//     const [summary, setSummary] = useState({
//         totalAmount: 0,
//         totalVAT: 0,
//         grandTotal: 0,
//         paymentMethods: {
//             cash: 0,
//             bank: 0,
//             other: 0
//         }
//     });

//     const backendUrl = process.env.REACT_APP_BACKEND_URL;
//     const userInfo = JSON.parse(localStorage.getItem("user-info"));
//     const token = userInfo?.token;
//     const origin = localStorage.getItem("user-origin");

//     useEffect(() => {
//         fetchData();
//         fetchFilterOptions();
//     }, [filters]);

//     const fetchData = async () => {
//         try {
//             setLoading(true);
//             const response = await axios.get(`${backendUrl}/api/expense-report`, {
//                 params: filters,
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     "Tenant-Origin": origin,
//                 }
//             });

//             const data = response.data.data || [];
//             setExpenses(data);
//             calculateSummary(data);
//         } catch (error) {
//             console.error("Error loading expense report:", error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const fetchFilterOptions = async () => {
//         try {
//             const response = await axios.get(`${backendUrl}/api/expense-report/filter-options`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     "Tenant-Origin": origin,
//                 }
//             });
//             setFilterOptions(response.data);
//         } catch (error) {
//             console.error("Error loading filter options:", error);
//         }
//     };

//     const calculateSummary = (data) => {
//         let totalAmount = 0;
//         let totalVAT = 0;
//         let paymentMethods = {
//             cash: 0,
//             bank: 0,
//             other: 0
//         };

//         data.forEach(expense => {
//             totalAmount += parseFloat(expense.amount_excl_vat);
//             totalVAT += parseFloat(expense.vat_amount);

//             if (expense.payment_mode === 'Cash') paymentMethods.cash += parseFloat(expense.total);
//             else if (expense.payment_mode === 'Bank') paymentMethods.bank += parseFloat(expense.total);
//             else paymentMethods.other += parseFloat(expense.total);
//         });

//         setSummary({
//             totalAmount,
//             totalVAT,
//             grandTotal: totalAmount + totalVAT,
//             paymentMethods
//         });
//     };

//     const handleFilterChange = (e) => {
//         const { name, value } = e.target;
//         setFilters(prev => ({ ...prev, [name]: value }));
//     };

//     const exportToExcel = () => {
//         const excelData = expenses.map(expense => ({
//             'Date': moment(expense.date).format('DD/MM/YYYY'),
//             'Description': expense.description,
//             'Project': expense.project,
//             'Client': expense.client,
//             'Vendor': expense.vendor,
//             'User': expense.user,
//             'Category': expense.category,
//             'Type': expense.type,
//             'Amount ': expense.amount_excl_vat,
//             'VAT %': expense.vat_percent,
//             'VAT Amount ': expense.vat_amount,
//             'Total': expense.total,
//             'Payment Mode': expense.payment_mode,
//             'Tax Type': expense.tax_type
//         }));

//         const worksheet = XLSX.utils.json_to_sheet(excelData);
//         const workbook = XLSX.utils.book_new();
//         XLSX.utils.book_append_sheet(workbook, worksheet, "Expense Report");

//         const excelBuffer = XLSX.write(workbook, {
//             bookType: 'xlsx',
//             type: 'array'
//         });

//         const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
//         saveAs(blob, `Expense_Report_${moment().format('YYYYMMDD')}.xlsx`);
//     };

//     const formatCurrency = (amount) => {
//         return new Intl.NumberFormat('en-AE', {
//             minimumFractionDigits: 2,
//             maximumFractionDigits: 2
//         }).format(amount);
//     };
//     const clearFilters = () => {
//         setFilters({
//             dateRange: 'this_month',
//             project: '',
//             vendor: '',
//             client: '',
//             category: '',
//         });
//         fetchData(); // Optional: fetch default data
//     };


//     return (
//         <div className="main-content" style={{ backgroundColor: '#f8f9fa' }}>
//             <div className="page-content">
//                 <div className="container-fluid">
//                     {/* Header Section */}
//                     <div className="row mb-4">
//                         <div className="col-12">
//                             <div className="d-flex justify-content-between align-items-center">
//                                 <div>
//                                     <h4 className="mb-0" style={{ color: '#2e3a4d', fontWeight: 600 }}>Expense Report</h4>
//                                     <p className="text-muted mb-0">Track and analyze your business expenses</p>
//                                 </div>
//                                 <button
//                                     onClick={exportToExcel}
//                                     className="btn btn-success"
//                                     style={{
//                                         backgroundColor: '#00a859',
//                                         borderColor: '#00a859',
//                                         borderRadius: '4px',
//                                         padding: '8px 16px'
//                                     }}
//                                 >
//                                     <i className="mdi mdi-file-excel-outline me-2"></i> Export to Excel
//                                 </button>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Filter Section */}
//                     <div className="row mb-4">
//                         <div className="col-12">
//                             <div className="card border-0 shadow-sm">
//                                 <div className="card-body p-3">
//                                     <div className="row g-3">
//                                         <div className="col-md-2">
//                                             <label className="form-label small text-muted mb-1">Date Range</label>
//                                             <select
//                                                 name="dateRange"
//                                                 value={filters.dateRange}
//                                                 onChange={handleFilterChange}
//                                                 className="form-select form-select-sm"
//                                             >
//                                                 <option value="this_month">This Month</option>
//                                                 <option value="last_month">Last Month</option>
//                                                 <option value="this_quarter">This Quarter</option>
//                                                 <option value="last_quarter">Last Quarter</option>
//                                                 <option value="this_year">This Year</option>
//                                                 <option value="custom">Custom Range</option>
//                                             </select>
//                                         </div>
//                                         <div className="col-md-2">
//                                             <label className="form-label small text-muted mb-1">Project</label>
//                                             <select
//                                                 name="project"
//                                                 value={filters.project}
//                                                 onChange={handleFilterChange}
//                                                 className="form-select form-select-sm"
//                                             >
//                                                 <option value="">All Projects</option>
//                                                 {filterOptions.projects.map(project => (
//                                                     <option key={project.id} value={project.id}>{project.name}</option>
//                                                 ))}
//                                             </select>
//                                         </div>
//                                         <div className="col-md-2">
//                                             <label className="form-label small text-muted mb-1">Vendor</label>
//                                             <select
//                                                 name="vendor"
//                                                 value={filters.vendor}
//                                                 onChange={handleFilterChange}
//                                                 className="form-select form-select-sm"
//                                             >
//                                                 <option value="">All Vendors</option>
//                                                 {filterOptions.vendors.map(vendor => (
//                                                     <option key={vendor.id} value={vendor.id}>{vendor.name}</option>
//                                                 ))}
//                                             </select>
//                                         </div>
//                                         <div className="col-md-2">
//                                             <label className="form-label small text-muted mb-1">Client</label>
//                                             <select
//                                                 name="client"
//                                                 value={filters.client}
//                                                 onChange={handleFilterChange}
//                                                 className="form-select form-select-sm"
//                                             >
//                                                 <option value="">All Clients</option>
//                                                 {filterOptions.clients.map(client => (
//                                                     <option key={client.id} value={client.id}>{client.name}</option>
//                                                 ))}
//                                             </select>
//                                         </div>
//                                         <div className="col-md-2">
//                                             <label className="form-label small text-muted mb-1">Category</label>
//                                             <select
//                                                 name="category"
//                                                 value={filters.category}
//                                                 onChange={handleFilterChange}
//                                                 className="form-select form-select-sm"
//                                             >
//                                                 <option value="">All Categories</option>
//                                                 {filterOptions.categories.map(category => (
//                                                     <option key={category.id} value={category.id}>{category.name}</option>
//                                                 ))}
//                                             </select>
//                                         </div>
//                                         <div className="col-md-2 d-flex flex-column justify-content-end gap-2">
//                                             <button
//                                                 onClick={fetchData}
//                                                 className="btn btn-outline-primary btn-sm"
//                                             >
//                                                 <i className="mdi mdi-filter-outline me-2"></i> Apply Filters
//                                             </button>
//                                             <button
//                                                 onClick={clearFilters}
//                                                 className="btn btn-outline-secondary btn-sm"
//                                             >
//                                                 Clear
//                                             </button>
//                                         </div>

//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Summary Cards */}
//                     <div className="row mb-4">
//                         <div className="col-md-4">
//                             <div className="card border-0 shadow-sm" style={{ backgroundColor: '#f8f9fa' }}>
//                                 <div className="card-body">
//                                     <div className="d-flex justify-content-between align-items-center">
//                                         <div>
//                                             <h6 className="text-muted mb-2">Total Expenses</h6>
//                                             <h3 className="mb-0" style={{ color: '#2e3a4d' }}>{formatCurrency(summary.grandTotal)}</h3>
//                                         </div>
//                                         <div className="bg-primary bg-opacity-10 p-3 rounded">
//                                             <i className="mdi mdi-cash-multiple text-primary" style={{ fontSize: '24px' }}></i>
//                                         </div>
//                                     </div>
//                                     <div className="mt-3">
//                                         <div className="d-flex justify-content-between">
//                                             <span className="text-muted small">Amount (excl. VAT)</span>
//                                             <span className="fw-medium">{formatCurrency(summary.totalAmount)}</span>
//                                         </div>
//                                         <div className="d-flex justify-content-between">
//                                             <span className="text-muted small">VAT Amount</span>
//                                             <span className="fw-medium">{formatCurrency(summary.totalVAT)}</span>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>

//                         <div className="col-md-8">
//                             <div className="card border-0 shadow-sm">
//                                 <div className="card-body">
//                                     <h6 className="card-title mb-3" style={{ color: '#2e3a4d' }}>Payment Methods Breakdown</h6>
//                                     <div className="row">
//                                         <div className="col-md-4">
//                                             <div className="d-flex align-items-center mb-3">
//                                                 <div className="bg-primary bg-opacity-10 p-2 rounded me-3">
//                                                     <i className="mdi mdi-bank text-primary"></i>
//                                                 </div>
//                                                 <div>
//                                                     <p className="text-muted mb-0 small">Bank Transfer</p>
//                                                     <h5 className="mb-0">{formatCurrency(summary.paymentMethods.bank)}</h5>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                         <div className="col-md-4">
//                                             <div className="d-flex align-items-center mb-3">
//                                                 <div className="bg-success bg-opacity-10 p-2 rounded me-3">
//                                                     <i className="mdi mdi-cash text-success"></i>
//                                                 </div>
//                                                 <div>
//                                                     <p className="text-muted mb-0 small">Cash</p>
//                                                     <h5 className="mb-0">{formatCurrency(summary.paymentMethods.cash)}</h5>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                         <div className="col-md-4">
//                                             <div className="d-flex align-items-center mb-3">
//                                                 <div className="bg-secondary bg-opacity-10 p-2 rounded me-3">
//                                                     <i className="mdi mdi-wallet text-secondary"></i>
//                                                 </div>
//                                                 <div>
//                                                     <p className="text-muted mb-0 small">Other</p>
//                                                     <h5 className="mb-0">{formatCurrency(summary.paymentMethods.other)}</h5>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Expense Table */}

//                     <div className="row">
//                         <div className="col-12">
//                             <div className="card border-0 shadow-sm">
//                                 <div className="card-body p-0">
//                                     {expenses.length === 0 ? (

//                                         <div className="text-center py-5">
//                                             <i className="mdi mdi-file-document-outline text-muted" style={{ fontSize: '48px' }}></i>
//                                             <h5 className="mt-3" style={{ color: '#2e3a4d' }}>No expenses found</h5>
//                                             <p className="text-muted">Try adjusting your filters or add new expenses</p>
//                                         </div>
//                                     ) : (
//                                         <div className="table-responsive">
//                                             <table className="table table-hover table-centered table-nowrap mb-0">
//                                                 <thead style={{ backgroundColor: '#f8f9fa' }} className='table-sales-gradient'>
//                                                     <tr>
//                                                         <th className="border-0">Date</th>
//                                                         <th className="border-0">Description</th>
//                                                         <th className="border-0">Project</th>
//                                                         <th className="border-0">Vendor</th>
//                                                         <th className="border-0">User</th>

//                                                         <th className="border-0 text-end">Amount</th>
//                                                         <th className="border-0 text-end">VAT(5%)</th>
//                                                         <th className="border-0 text-end">Total</th>
//                                                         <th className="border-0">Payment</th>
//                                                         <th className="border-0">Tax</th>
//                                                     </tr>
//                                                 </thead>
//                                                 <tbody>
//                                                     {expenses.map((expense, index) => (
//                                                         <tr key={index} style={{ borderBottom: '1px solid #f1f3f9' }}>
//                                                             <td style={{ color: '#6c757d' }}>{moment(expense.date).format('DD MMM YY')}</td>
//                                                             <td>
//                                                                 <span className="d-block fw-medium" style={{ color: '#2e3a4d' }}>
//                                                                     {expense.narration || ' '}
//                                                                 </span>
//                                                                 <small className="text-muted">{expense.type}</small>
//                                                             </td>
//                                                             <td>{expense.project || ''}</td>
//                                                             <td>{expense.vendor || ''}</td>
//                                                             <td>{expense.user || ''}</td>

//                                                             <td className="text-end">{formatCurrency(expense.amount_excl_vat)}</td>
//                                                             <td className="text-end">
//                                                                 {expense.vat_percent > 0 ? (
//                                                                     <span className="text-success">
//                                                                         {formatCurrency(expense.vat_amount)} 
//                                                                     </span>
//                                                                 ) : ''}
//                                                             </td>
//                                                             <td className="text-end fw-medium" style={{ color: '#2e3a4d' }}>
//                                                                 {formatCurrency(expense.total)}
//                                                             </td>
//                                                             <td>
//                                                                 <span className={`badge ${expense.payment_mode === 'Bank' ? 'bg-primary' : expense.payment_mode === 'Cash' ? 'bg-success' : 'bg-secondary'}`}>
//                                                                     {expense.payment_mode}
//                                                                 </span>
//                                                             </td>
//                                                             <td>
//                                                                 <span className={`badge ${expense.tax_type === 'taxable' ? 'bg-info' : 'bg-light text-dark'}`}>
//                                                                     {expense.tax_type || 'N/A'}
//                                                                 </span>
//                                                             </td>
//                                                         </tr>
//                                                     ))}
//                                                 </tbody>
//                                                 <tfoot style={{ backgroundColor: '#f8f9fa' }}>
//                                                     <tr>
//                                                         <th colSpan="5" className="text-end">Totals:</th>
//                                                         <th className="text-end">{formatCurrency(summary.totalAmount)}</th>
//                                                         <th className="text-end">{formatCurrency(summary.totalVAT)}</th>
//                                                         <th className="text-end">{formatCurrency(summary.grandTotal)}</th>
//                                                         <th colSpan="2"></th>
//                                                     </tr>
//                                                 </tfoot>
//                                             </table>
//                                         </div>
//                                     )}
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>

//     );
// };

// export default ExpenseReport;


// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { saveAs } from 'file-saver';
// import * as XLSX from 'xlsx';
// import moment from 'moment';
// import Offcanvas from 'react-bootstrap/Offcanvas';

// const ExpenseReport = () => {
//     const [expenses, setExpenses] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [filters, setFilters] = useState({
//         dateRange: 'this_month',
//         project: '',
//         vendor: '',
//         client: '',
//         category: ''
//     });
//     const [filterOptions, setFilterOptions] = useState({
//         projects: [],
//         vendors: [],
//         clients: [],
//         categories: []
//     });
//     const [summary, setSummary] = useState({
//         totalAmount: 0,
//         totalVAT: 0,
//         grandTotal: 0,
//         adjustmentAmount: 0,
//         paymentMethods: {
//             cash: 0,
//             bank: 0,
//             other: 0
//         }
//     });
//     const [selectedExpense, setSelectedExpense] = useState(null);
//     const [showModal, setShowModal] = useState(false);

//     const backendUrl = process.env.REACT_APP_BACKEND_URL;
//     const userInfo = JSON.parse(localStorage.getItem("user-info"));
//     const token = userInfo?.token;
//     const origin = localStorage.getItem("user-origin");

//     useEffect(() => {
//         fetchData();
//         fetchFilterOptions();
//     }, [filters]);

//     const fetchData = async () => {
//         try {
//             setLoading(true);
//             const response = await axios.get(`${backendUrl}/api/expense-report`, {
//                 params: filters,
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     "Tenant-Origin": origin,
//                 }
//             });

//             const data = response.data.data || [];
//             setExpenses(data);
//             calculateSummary(data);
//         } catch (error) {
//             console.error("Error loading expense report:", error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const fetchFilterOptions = async () => {
//         try {
//             const response = await axios.get(`${backendUrl}/api/expense-report/filter-options`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     "Tenant-Origin": origin,
//                 }
//             });
//             setFilterOptions(response.data);
//         } catch (error) {
//             console.error("Error loading filter options:", error);
//         }
//     };

//     const calculateSummary = (data) => {
//         let totalAmount = 0;
//         let totalVAT = 0;
//         let adjustmentAmount = 0;
//         let paymentMethods = {
//             cash: 0,
//             bank: 0,
//             other: 0
//         };

//         data.forEach(expense => {
//             totalAmount += parseFloat(expense.amount_excl_vat);
//             totalVAT += parseFloat(expense.vat_amount);
//             adjustmentAmount += parseFloat(expense.adjustment_amount || 0);

//             if (expense.payment_mode === 'Cash') paymentMethods.cash += parseFloat(expense.total);
//             else if (expense.payment_mode === 'Bank') paymentMethods.bank += parseFloat(expense.total);
//             else paymentMethods.other += parseFloat(expense.total);
//         });

//         setSummary({
//             totalAmount,
//             totalVAT,
//             adjustmentAmount,
//             grandTotal: totalAmount + totalVAT + adjustmentAmount,
//             paymentMethods
//         });
//     };

//     const handleFilterChange = (e) => {
//         const { name, value } = e.target;
//         setFilters(prev => ({ ...prev, [name]: value }));
//     };

//     const handleExpenseClick = (expense) => {
//         setSelectedExpense(expense);
//         setShowModal(true);
//     };

//     const exportToExcel = () => {
//         const excelData = expenses.map(expense => ({
//             'Date': moment(expense.date).format('DD/MM/YYYY'),
//             'Description': expense.description,
//             'Project': expense.project,
//             'Client': expense.client,
//             'Vendor': expense.vendor,
//             'User': expense.user,
//             'Category': expense.category,
//             'Type': expense.type,
//             'Amount ': expense.amount_excl_vat,
//             'VAT %': expense.vat_percent,
//             'VAT Amount ': expense.vat_amount,
//             'Total': expense.total,
//             'Payment Mode': expense.payment_mode,
//             'Tax Type': expense.tax_type
//         }));

//         const worksheet = XLSX.utils.json_to_sheet(excelData);
//         const workbook = XLSX.utils.book_new();
//         XLSX.utils.book_append_sheet(workbook, worksheet, "Expense Report");

//         const excelBuffer = XLSX.write(workbook, {
//             bookType: 'xlsx',
//             type: 'array'
//         });

//         const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
//         saveAs(blob, `Expense_Report_${moment().format('YYYYMMDD')}.xlsx`);
//     };

//     const formatCurrency = (amount) => {
//         return new Intl.NumberFormat('en-AE', {
//             minimumFractionDigits: 2,
//             maximumFractionDigits: 2
//         }).format(amount);
//     };

//     const clearFilters = () => {
//         setFilters({
//             dateRange: 'this_month',
//             project: '',
//             vendor: '',
//             client: '',
//             category: '',
//         });
//         fetchData();
//     };

//     return (
//         <div className="main-content" style={{ backgroundColor: '#f8f9fa' }}>
//             <div className="page-content">
//                 <div className="container-fluid">
//                     {/* Header Section */}
//                     <div className="row mb-4">
//                         <div className="col-12">
//                             <div className="d-flex justify-content-between align-items-center">
//                                 <div>
//                                     <h4 className="mb-0" style={{ color: '#2e3a4d', fontWeight: 600 }}>Expense Report</h4>
//                                     <p className="text-muted mb-0">Track and analyze your business expenses</p>
//                                 </div>
//                                 <button
//                                     onClick={exportToExcel}
//                                     className="btn btn-success"
//                                     style={{
//                                         backgroundColor: '#00a859',
//                                         borderColor: '#00a859',
//                                         borderRadius: '4px',
//                                         padding: '8px 16px'
//                                     }}
//                                 >
//                                     <i className="mdi mdi-file-excel-outline me-2"></i> Export to Excel
//                                 </button>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Filter Section */}
//                     <div className="row mb-4">
//                         <div className="col-12">
//                             <div className="card border-0 shadow-sm">
//                                 <div className="card-body p-3">
//                                     <div className="row g-3">
//                                         <div className="col-md-2">
//                                             <label className="form-label small text-muted mb-1">Date Range</label>
//                                             <select
//                                                 name="dateRange"
//                                                 value={filters.dateRange}
//                                                 onChange={handleFilterChange}
//                                                 className="form-select form-select-sm"
//                                             >
//                                                 <option value="this_month">This Month</option>
//                                                 <option value="last_month">Last Month</option>
//                                                 <option value="this_quarter">This Quarter</option>
//                                                 <option value="last_quarter">Last Quarter</option>
//                                                 <option value="this_year">This Year</option>
//                                             </select>
//                                         </div>
//                                         <div className="col-md-2">
//                                             <label className="form-label small text-muted mb-1">Project</label>
//                                             <select
//                                                 name="project"
//                                                 value={filters.project}
//                                                 onChange={handleFilterChange}
//                                                 className="form-select form-select-sm"
//                                             >
//                                                 <option value="">All Projects</option>
//                                                 {filterOptions.projects.map(project => (
//                                                     <option key={project.id} value={project.id}>{project.name}</option>
//                                                 ))}
//                                             </select>
//                                         </div>
//                                         <div className="col-md-2">
//                                             <label className="form-label small text-muted mb-1">Vendor</label>
//                                             <select
//                                                 name="vendor"
//                                                 value={filters.vendor}
//                                                 onChange={handleFilterChange}
//                                                 className="form-select form-select-sm"
//                                             >
//                                                 <option value="">All Vendors</option>
//                                                 {filterOptions.vendors.map(vendor => (
//                                                     <option key={vendor.id} value={vendor.id}>{vendor.name}</option>
//                                                 ))}
//                                             </select>
//                                         </div>
//                                         <div className="col-md-2">
//                                             <label className="form-label small text-muted mb-1">Client</label>
//                                             <select
//                                                 name="client"
//                                                 value={filters.client}
//                                                 onChange={handleFilterChange}
//                                                 className="form-select form-select-sm"
//                                             >
//                                                 <option value="">All Clients</option>
//                                                 {filterOptions.clients.map(client => (
//                                                     <option key={client.id} value={client.id}>{client.name}</option>
//                                                 ))}
//                                             </select>
//                                         </div>
//                                         <div className="col-md-2">
//                                             <label className="form-label small text-muted mb-1">Category</label>
//                                             <select
//                                                 name="category"
//                                                 value={filters.category}
//                                                 onChange={handleFilterChange}
//                                                 className="form-select form-select-sm"
//                                             >
//                                                 <option value="">All Categories</option>
//                                                 {filterOptions.categories.map(category => (
//                                                     <option key={category.id} value={category.id}>{category.name}</option>
//                                                 ))}
//                                             </select>
//                                         </div>
//                                         <div className="col-md-2 d-flex flex-column justify-content-end gap-2">
//                                             <button
//                                                 onClick={fetchData}
//                                                 className="btn btn-outline-primary btn-sm"
//                                             >
//                                                 <i className="mdi mdi-filter-outline me-2"></i> Apply Filters
//                                             </button>
//                                             <button
//                                                 onClick={clearFilters}
//                                                 className="btn btn-outline-secondary btn-sm"
//                                             >
//                                                 Clear
//                                             </button>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Summary Cards */}
//                     <div className="row mb-4">
//                         <div className="col-md-4">
//                             <div className="card border-0 shadow-sm" style={{ backgroundColor: '#f8f9fa' }}>
//                                 <div className="card-body">
//                                     <div className="d-flex justify-content-between align-items-center">
//                                         <div>
//                                             <h6 className="text-muted mb-2">Total Expenses</h6>
//                                             <h3 className="mb-0" style={{ color: '#2e3a4d' }}>{formatCurrency(summary.grandTotal)}</h3>
//                                         </div>
//                                         <div className="bg-primary bg-opacity-10 p-3 rounded">
//                                             <i className="mdi mdi-cash-multiple text-primary" style={{ fontSize: '24px' }}></i>
//                                         </div>
//                                     </div>
//                                     <div className="mt-3">
//                                         <div className="d-flex justify-content-between">
//                                             <span className="text-muted small">Amount (excl. VAT)</span>
//                                             <span className="fw-medium">{formatCurrency(summary.totalAmount)}</span>
//                                         </div>
//                                         <div className="d-flex justify-content-between">
//                                             <span className="text-muted small">Adjustment Amount</span>
//                                             <span className="fw-medium">{formatCurrency(summary.adjustmentAmount)}</span>
//                                         </div>
//                                         <div className="d-flex justify-content-between">
//                                             <span className="text-muted small">VAT Amount</span>
//                                             <span className="fw-medium">{formatCurrency(summary.totalVAT)}</span>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>

//                         <div className="col-md-8">
//                             <div className="card border-0 shadow-sm">
//                                 <div className="card-body">
//                                     <h6 className="card-title mb-3" style={{ color: '#2e3a4d' }}>Payment Methods Breakdown</h6>
//                                     <div className="row">
//                                         <div className="col-md-4">
//                                             <div className="d-flex align-items-center mb-3">
//                                                 <div className="bg-primary bg-opacity-10 p-2 rounded me-3">
//                                                     <i className="mdi mdi-bank text-primary"></i>
//                                                 </div>
//                                                 <div>
//                                                     <p className="text-muted mb-0 small">Bank Transfer</p>
//                                                     <h5 className="mb-0">{formatCurrency(summary.paymentMethods.bank)}</h5>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                         <div className="col-md-4">
//                                             <div className="d-flex align-items-center mb-3">
//                                                 <div className="bg-success bg-opacity-10 p-2 rounded me-3">
//                                                     <i className="mdi mdi-cash text-success"></i>
//                                                 </div>
//                                                 <div>
//                                                     <p className="text-muted mb-0 small">Cash</p>
//                                                     <h5 className="mb-0">{formatCurrency(summary.paymentMethods.cash)}</h5>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                         <div className="col-md-4">
//                                             <div className="d-flex align-items-center mb-3">
//                                                 <div className="bg-secondary bg-opacity-10 p-2 rounded me-3">
//                                                     <i className="mdi mdi-wallet text-secondary"></i>
//                                                 </div>
//                                                 <div>
//                                                     <p className="text-muted mb-0 small">Other</p>
//                                                     <h5 className="mb-0">{formatCurrency(summary.paymentMethods.other)}</h5>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Expense Table */}
//                     <div className="row">
//                         <div className="col-12">
//                             <div className="card border-0 shadow-sm">
//                                 <div className="card-body">
//                                     {expenses.length === 0 ? (
//                                         <div className="text-center py-5">
//                                             <i className="mdi mdi-file-document-outline text-muted" style={{ fontSize: '48px' }}></i>
//                                             <h5 className="mt-3" style={{ color: '#2e3a4d' }}>No expenses found</h5>
//                                             <p className="text-muted">Try adjusting your filters or add new expenses</p>
//                                         </div>
//                                     ) : (
//                                         <div className="table-responsive">
//                                             <table className="table align-middle table-nowrap table-check table-list">
//                                                 <thead className='table-sales-gradient'>
//                                                     <tr>
//                                                         <th style={{ width: '20px' }} className="align-middle">
//                                                             <div className="form-check font-size-16">
//                                                                 <input className="form-check-input" type="checkbox" id="checkAll" />
//                                                                 <label className="form-check-label" htmlFor="checkAll"></label>
//                                                             </div>
//                                                         </th>
//                                                         <th className="align-middle">#</th>
//                                                         <th className="border-0">Date</th>
//                                                         <th className="border-0">Description</th>
//                                                         <th className="border-0">Project</th>
//                                                         <th className="border-0">Vendor/Client</th>
//                                                         <th className="border-0">User</th>
//                                                         <th className="border-0 text-end">Amount</th>
//                                                         <th className="border-0 text-end">VAT(5%)</th>
//                                                         <th className="border-0 ">Adjustment Amount</th>
//                                                         <th className="border-0 text-end">Total</th>
//                                                         <th className="border-0">Payment</th>
//                                                         <th className="border-0">Tax</th>
//                                                     </tr>
//                                                 </thead>
//                                                 <tbody>
//                                                     {expenses.map((expense, index) => (
//                                                         <tr key={index} style={{ borderBottom: '1px solid #f1f3f9' }}>
//                                                             <td>
//                                                                 <div className="form-check font-size-16">
//                                                                     <input
//                                                                         className="form-check-input"
//                                                                         type="checkbox"
//                                                                         id={`transactionCheck${index}`}
//                                                                     />
//                                                                     <label
//                                                                         className="form-check-label"
//                                                                         htmlFor={`transactionCheck${index}`}
//                                                                     ></label>
//                                                                 </div>
//                                                             </td>
//                                                             <td>{index + 1}</td>

//                                                             <td
//                                                                 style={{ color: '#6c757d', cursor: 'pointer' }}
//                                                                 onClick={() => handleExpenseClick(expense)}
//                                                             >
//                                                                 {(expense.date)}
//                                                             </td>
//                                                             <td>
//                                                                 <span className="d-block fw-medium" style={{ color: '#2e3a4d' }}>
//                                                                     {expense.narration || ' '}
//                                                                 </span>
//                                                                 <small className="text-muted">{expense.type}</small>
//                                                             </td>
//                                                             <td>{expense.project || ''}</td>
//                                                             <td>{expense.vendor || expense.client || ''}</td>
//                                                             <td>{expense.user || ''}</td>
//                                                             <td className="text-end">{formatCurrency(expense.amount_excl_vat)}</td>
//                                                             <td className="text-end">
//                                                                 {expense.vat_percent > 0 ? (
//                                                                     <span className="text-success">
//                                                                         {formatCurrency(expense.vat_amount)}
//                                                                     </span>
//                                                                 ) : ''}
//                                                             </td>
//                                                             <td>{formatCurrency(expense.adjustment_amount || 0)}</td>
//                                                             <td className="text-end fw-medium" style={{ color: '#2e3a4d' }}>
//                                                                 {formatCurrency(expense.total)}
//                                                             </td>
//                                                             <td>
//                                                                 <span className={`badge ${expense.payment_mode === 'Bank' ? 'bg-primary' : expense.payment_mode === 'Cash' ? 'bg-success' : 'bg-secondary'}`}>
//                                                                     {expense.payment_mode}
//                                                                 </span>
//                                                             </td>
//                                                             <td>
//                                                                 <span className={`badge ${expense.tax_type === 'taxable' ? 'bg-info' : 'bg-light text-dark'}`}>
//                                                                     {expense.tax_type || 'N/A'}
//                                                                 </span>
//                                                             </td>
//                                                         </tr>
//                                                     ))}
//                                                 </tbody>
//                                                 <tfoot style={{ backgroundColor: '#f8f9fa' }}>
//                                                     <tr>
//                                                         <th colSpan="7" className="text-end">Totals:</th>
//                                                         <th className="text-end">{formatCurrency(summary.totalAmount)}</th>
//                                                         <th className="text-end">{formatCurrency(summary.totalVAT)}</th>
//                                                         <th>{formatCurrency(summary.adjustmentAmount)}</th>

//                                                         <th className="text-end">{formatCurrency(summary.grandTotal)}</th>
//                                                         <th colSpan="2"></th>
//                                                     </tr>
//                                                 </tfoot>
//                                             </table>
//                                         </div>
//                                     )}
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* Expense Details Offcanvas Modal */}
//             <Offcanvas
//                 show={showModal}
//                 onHide={() => setShowModal(false)}
//                 placement="end"
//                 style={{ width: '600px' }}
//             >
//                 <Offcanvas.Header closeButton className="border-bottom">
//                     <Offcanvas.Title className="text-primary">
//                         <i className="mdi mdi-receipt me-2"></i>
//                         Expense Details
//                     </Offcanvas.Title>
//                 </Offcanvas.Header>
//                 <Offcanvas.Body>
//                     {selectedExpense && (
//                         <div>
//                             {/* Expense Header Card */}
//                             <div className="card shadow-sm mb-4 border-0 bg-light">
//                                 <div className="card-body">
//                                     <div className="d-flex justify-content-between align-items-center mb-3">
//                                         <div>
//                                             <h6 className="text-muted mb-1">Expense Date</h6>
//                                             <p className="mb-0 fw-bold">{moment(selectedExpense.date).format('DD MMM YYYY')}</p>
//                                         </div>
//                                         <div className="text-end">
//                                             <h6 className="text-muted mb-1">Reference</h6>
//                                             <span className="badge bg-primary">{selectedExpense?.transaction?.reference || ''}</span>
//                                         </div>
//                                     </div>

//                                     <div className="mt-3">
//                                         <h6 className="text-muted mb-1">Description</h6>
//                                         <p className="mb-0 fw-semibold">{selectedExpense.narration || selectedExpense.description}</p>
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Basic Information */}
//                             <div className="row mb-4">
//                                 <div className="col-md-6">
//                                     <div className="card border-0 shadow-sm mb-3">
//                                         <div className="card-body">
//                                             <h6 className="text-muted mb-2">Basic Information</h6>
//                                             <div className="d-flex justify-content-between mb-2">
//                                                 <span className="small text-muted">
//                                                     {selectedExpense.vendor ? 'Vendor' : 'User'}
//                                                 </span>
//                                                 <span className="fw-medium">
//                                                     {selectedExpense.vendor ? selectedExpense.vendor : selectedExpense.user || ''}
//                                                 </span>
//                                             </div>


//                                             <div className="d-flex justify-content-between mb-2">
//                                                 <span className="small text-muted">Project:</span>
//                                                 <span className="fw-medium">{selectedExpense.project || ''}</span>
//                                             </div>
//                                             <div className="d-flex justify-content-between mb-2">
//                                                 <span className="small text-muted">Category:</span>
//                                                 <span className="fw-medium">{selectedExpense.category || ''}</span>
//                                             </div>
//                                             <div className="d-flex justify-content-between mb-2">
//                                                 <span className="small text-muted">Invoice No:</span>
//                                                 <span className="fw-medium">{selectedExpense.invoice_no || ''}</span>
//                                             </div>
//                                             {/* <div className="d-flex justify-content-between">
//                                                 <span className="small text-muted">Entered By:</span>
//                                                 <span className="fw-medium">{selectedExpense.user || 'N/A'}</span>
//                                             </div> */}
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div className="col-md-6">
//                                     <div className="card border-0 shadow-sm mb-3">
//                                         <div className="card-body">
//                                             <h6 className="text-muted mb-2">Financial Details</h6>
//                                             <div className="d-flex justify-content-between mb-2">
//                                                 <span className="small text-muted">Amount:</span>
//                                                 <span className="fw-medium">{formatCurrency(selectedExpense.amount_excl_vat)}</span>
//                                             </div>
//                                             <div className="d-flex justify-content-between mb-2">
//                                                 <span className="small text-muted">VAT ({selectedExpense.vat_percent || 0}%):</span>
//                                                 <span className="text-success">{formatCurrency(selectedExpense.vat_amount || 0)}</span>
//                                             </div>
//                                             <div className="d-flex justify-content-between mb-2">
//                                                 <span className="small text-muted">Adjustment Amount:</span>
//                                                 <span className="text-success">{formatCurrency(selectedExpense.adjustment_amount || 0)}</span>
//                                             </div>
//                                             <div className="d-flex justify-content-between mb-2">
//                                                 <span className="small text-muted">Total:</span>
//                                                 <span className="fw-bold text-primary">{formatCurrency(selectedExpense.total)}</span>
//                                             </div>
//                                             <div className="d-flex justify-content-between">
//                                                 <span className="small text-muted">Tax Type:</span>
//                                                 <span className={`badge ${selectedExpense.tax_type === 'taxable' ? 'bg-info' : 'bg-light text-dark'}`}>
//                                                     {selectedExpense.tax_type || 'N/A'}
//                                                 </span>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Payment Details */}
//                             <div className="card border-0 shadow-sm mb-4">
//                                 <div className="card-body">
//                                     <h6 className="text-muted mb-3">
//                                         <i className="mdi mdi-credit-card-outline me-1"></i>
//                                         Payment Details
//                                     </h6>

//                                     <div className="d-flex justify-content-between align-items-center mb-3">
//                                         <span className="fw-semibold">Payment Method:</span>
//                                         <span className={`badge ${selectedExpense.payment_mode === 'Bank' ? 'bg-primary' : selectedExpense.payment_mode === 'Cash' ? 'bg-success' : 'bg-secondary'}`}>
//                                             {selectedExpense.payment_mode}
//                                         </span>
//                                     </div>

//                                     {/* Bank Payment Details (if applicable) */}
//                                     {selectedExpense.payment_mode === 'Bank' && (
//                                         <div className="mt-3 p-3 bg-light rounded">
//                                             <h6 className="text-muted mb-2">Bank Transfer Details</h6>
//                                             <div className="d-flex justify-content-between mb-2">
//                                                 <span className="small text-muted">Bank Name:</span>
//                                                 <span className="fw-medium">{selectedExpense?.transaction?.account_name || ''}</span>
//                                             </div>
//                                             <div className="d-flex justify-content-between mb-2">
//                                                 <span className="small text-muted">Account Number:</span>
//                                                 <span className="fw-medium">{selectedExpense?.transaction?.account_number || ''}</span>
//                                             </div>
//                                             <div className="d-flex justify-content-between mb-2">
//                                                 <span className="small text-muted">Transaction Reference:</span>
//                                                 <span className="fw-medium">{selectedExpense.transaction?.reference || ''}</span>
//                                             </div>
//                                             <div className="d-flex justify-content-between">
//                                                 <span className="small text-muted">Transfer Date:</span>
//                                                 <span className="fw-medium">{selectedExpense?.transaction?.transaction_date ? moment(selectedExpense.transfer_date).format('DD MMM YYYY') : 'N/A'}</span>
//                                             </div>
//                                         </div>
//                                     )}

//                                     {/* Cash Payment Details (if applicable) */}
//                                     {selectedExpense.payment_mode === 'Cash' && (
//                                         <div className="mt-3 p-3 bg-light rounded">
//                                             <h6 className="text-muted mb-2"> Transfer Details</h6>
//                                             <div className="d-flex justify-content-between mb-2">
//                                                 <span className="small text-muted">Account Name:</span>
//                                                 <span className="fw-medium">{selectedExpense?.transaction?.account_name || ''}</span>
//                                             </div>


//                                             <div className="d-flex justify-content-between">
//                                                 <span className="small text-muted">Transfer Date:</span>
//                                                 <span className="fw-medium">{selectedExpense?.transaction?.transaction_date ? moment(selectedExpense.transfer_date).format('DD MMM YYYY') : 'N/A'}</span>
//                                             </div>
//                                         </div>
//                                     )}

//                                     {/* Other Payment Details */}
//                                     {selectedExpense.payment_mode !== 'Bank' && selectedExpense.payment_mode !== 'Cash' && (
//                                         <div className="mt-3 p-3 bg-light rounded">
//                                             <h6 className="text-muted mb-2">Not paid via Bank or Cash</h6>
//                                             <p className="mb-0 small">Paid using {selectedExpense.payment_mode} method.</p>
//                                         </div>
//                                     )}
//                                 </div>
//                             </div>

//                             {/* Additional Information */}
//                             {selectedExpense.notes && (
//                                 <div className="card border-0 shadow-sm">
//                                     <div className="card-body">
//                                         <h6 className="text-muted mb-2">Additional Notes</h6>
//                                         <p className="mb-0">{selectedExpense.notes}</p>
//                                     </div>
//                                 </div>
//                             )}
//                         </div>
//                     )}
//                 </Offcanvas.Body>
//             </Offcanvas>
//         </div>
//     );
// };

// export default ExpenseReport;

// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { saveAs } from 'file-saver';
// import * as XLSX from 'xlsx';
// import moment from 'moment';
// import Offcanvas from 'react-bootstrap/Offcanvas';

// const ExpenseReport = () => {
//     const [expenses, setExpenses] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [filters, setFilters] = useState({
//         dateRange: 'this_month',
//         fromDate: '',
//         toDate: '',
//         project: '',
//         vendor: '',
//         client: '',
//         category: ''
//     });
//     const [filterOptions, setFilterOptions] = useState({
//         projects: [],
//         vendors: [],
//         clients: [],
//         categories: []
//     });
//     const [summary, setSummary] = useState({
//         totalAmount: 0,
//         totalVAT: 0,
//         grandTotal: 0,
//         adjustmentAmount: 0,
//         paymentMethods: {
//             cash: 0,
//             bank: 0,
//             other: 0
//         }
//     });
//     const [selectedExpense, setSelectedExpense] = useState(null);
//     const [showModal, setShowModal] = useState(false);

//     const backendUrl = process.env.REACT_APP_BACKEND_URL;
//     const userInfo = JSON.parse(localStorage.getItem("user-info"));
//     const token = userInfo?.token;
//     const origin = localStorage.getItem("user-origin");

//     useEffect(() => {
//         fetchData();
//         fetchFilterOptions();
//     }, [filters.dateRange]); // Only trigger when dateRange changes

//     const fetchData = async () => {
//         try {
//             setLoading(true);
//             const response = await axios.get(`${backendUrl}/api/expense-report`, {
//                 params: filters,
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     "Tenant-Origin": origin,
//                 }
//             });

//             const data = response.data.data || [];
//             setExpenses(data);
//             calculateSummary(data);
//         } catch (error) {
//             console.error("Error loading expense report:", error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const fetchFilterOptions = async () => {
//         try {
//             const response = await axios.get(`${backendUrl}/api/expense-report/filter-options`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     "Tenant-Origin": origin,
//                 }
//             });
//             setFilterOptions(response.data);
//         } catch (error) {
//             console.error("Error loading filter options:", error);
//         }
//     };

//     const calculateSummary = (data) => {
//         let totalAmount = 0;
//         let totalVAT = 0;
//         let adjustmentAmount = 0;
//         let paymentMethods = {
//             cash: 0,
//             bank: 0,
//             other: 0
//         };

//         data.forEach(expense => {
//             totalAmount += parseFloat(expense.amount_excl_vat);
//             totalVAT += parseFloat(expense.vat_amount);
//             adjustmentAmount += parseFloat(expense.adjustment_amount || 0);

//             if (expense.payment_mode === 'Cash') paymentMethods.cash += parseFloat(expense.total);
//             else if (expense.payment_mode === 'Bank') paymentMethods.bank += parseFloat(expense.total);
//             else paymentMethods.other += parseFloat(expense.total);
//         });

//         setSummary({
//             totalAmount,
//             totalVAT,
//             adjustmentAmount,
//             grandTotal: totalAmount + totalVAT + adjustmentAmount,
//             paymentMethods
//         });
//     };

//     const handleFilterChange = (e) => {
//         const { name, value } = e.target;

//         // If date range is selected, clear custom dates
//         if (name === 'dateRange' && value !== 'custom') {
//             setFilters(prev => ({ 
//                 ...prev, 
//                 [name]: value,
//                 fromDate: '',
//                 toDate: ''
//             }));
//         } else {
//             setFilters(prev => ({ ...prev, [name]: value }));
//         }
//     };

//     const handleExpenseClick = (expense) => {
//         setSelectedExpense(expense);
//         setShowModal(true);
//     };

//     const exportToExcel = () => {
//         const excelData = expenses.map(expense => ({
//             'Date': moment(expense.date).format('DD/MM/YYYY'),
//             'Description': expense.description,
//             'Project': expense.project,
//             'Client': expense.client,
//             'Vendor': expense.vendor,
//             'User': expense.user,
//             'Category': expense.category,
//             'Type': expense.type,
//             'Amount ': expense.amount_excl_vat,
//             'VAT %': expense.vat_percent,
//             'VAT Amount ': expense.vat_amount,
//             'Total': expense.total,
//             'Payment Mode': expense.payment_mode,
//             'Tax Type': expense.tax_type
//         }));

//         const worksheet = XLSX.utils.json_to_sheet(excelData);
//         const workbook = XLSX.utils.book_new();
//         XLSX.utils.book_append_sheet(workbook, worksheet, "Expense Report");

//         const excelBuffer = XLSX.write(workbook, {
//             bookType: 'xlsx',
//             type: 'array'
//         });

//         const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
//         saveAs(blob, `Expense_Report_${moment().format('YYYYMMDD')}.xlsx`);
//     };

//     const formatCurrency = (amount) => {
//         return new Intl.NumberFormat('en-AE', {
//             minimumFractionDigits: 2,
//             maximumFractionDigits: 2
//         }).format(amount);
//     };

//     const clearFilters = () => {
//         setFilters({
//             dateRange: 'this_month',
//             fromDate: '',
//             toDate: '',
//             project: '',
//             vendor: '',
//             client: '',
//             category: '',
//         });
//         // Don't fetch data immediately, wait for user to click Apply Filters
//     };

//     // Function to handle applying filters
//     const applyFilters = () => {
//         fetchData();
//     };

//     return (
//         <div className="main-content" style={{ backgroundColor: '#f8f9fa' }}>
//             <div className="page-content">
//                 <div className="container-fluid">
//                     {/* Header Section */}
//                     <div className="row mb-4">
//                         <div className="col-12">
//                             <div className="d-flex justify-content-between align-items-center">
//                                 <div>
//                                     <h4 className="mb-0" style={{ color: '#2e3a4d', fontWeight: 600 }}>Expense Report</h4>
//                                     <p className="text-muted mb-0">Track and analyze your business expenses</p>
//                                 </div>
//                                 <button
//                                     onClick={exportToExcel}
//                                     className="btn btn-success"
//                                     style={{
//                                         backgroundColor: '#00a859',
//                                         borderColor: '#00a859',
//                                         borderRadius: '4px',
//                                         padding: '8px 16px'
//                                     }}
//                                 >
//                                     <i className="mdi mdi-file-excel-outline me-2"></i> Export to Excel
//                                 </button>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Filter Section */}
//                     <div className="row mb-4">
//                         <div className="col-12">
//                             <div className="card border-0 shadow-sm">
//                                 <div className="card-body p-3">
//                                     <div className="row g-3">
//                                         <div className="col-md-2">
//                                             <label className="form-label small text-muted mb-1">Date Range</label>
//                                             <select
//                                                 name="dateRange"
//                                                 value={filters.dateRange}
//                                                 onChange={handleFilterChange}
//                                                 className="form-select form-select-sm"
//                                             >
//                                                 <option value="this_month">This Month</option>
//                                                 <option value="last_month">Last Month</option>
//                                                 <option value="this_quarter">This Quarter</option>
//                                                 <option value="last_quarter">Last Quarter</option>
//                                                 <option value="this_year">This Year</option>
//                                                 <option value="custom">Custom Date Range</option>
//                                             </select>
//                                         </div>

//                                         {/* Custom Date Range Fields - Only show when "Custom" is selected */}
//                                         {filters.dateRange === 'custom' && (
//                                             <>
//                                                 <div className="col-md-2">
//                                                     <label className="form-label small text-muted mb-1">From Date</label>
//                                                     <input
//                                                         type="date"
//                                                         name="fromDate"
//                                                         value={filters.fromDate}
//                                                         onChange={handleFilterChange}
//                                                         className="form-control form-control-sm"
//                                                     />
//                                                 </div>
//                                                 <div className="col-md-2">
//                                                     <label className="form-label small text-muted mb-1">To Date</label>
//                                                     <input
//                                                         type="date"
//                                                         name="toDate"
//                                                         value={filters.toDate}
//                                                         onChange={handleFilterChange}
//                                                         className="form-control form-control-sm"
//                                                     />
//                                                 </div>
//                                             </>
//                                         )}

//                                         <div className="col-md-2">
//                                             <label className="form-label small text-muted mb-1">Project</label>
//                                             <select
//                                                 name="project"
//                                                 value={filters.project}
//                                                 onChange={handleFilterChange}
//                                                 className="form-select form-select-sm"
//                                             >
//                                                 <option value="">All Projects</option>
//                                                 {filterOptions.projects.map(project => (
//                                                     <option key={project.id} value={project.id}>{project.name}</option>
//                                                 ))}
//                                             </select>
//                                         </div>
//                                         <div className="col-md-2">
//                                             <label className="form-label small text-muted mb-1">Vendor</label>
//                                             <select
//                                                 name="vendor"
//                                                 value={filters.vendor}
//                                                 onChange={handleFilterChange}
//                                                 className="form-select form-select-sm"
//                                             >
//                                                 <option value="">All Vendors</option>
//                                                 {filterOptions.vendors.map(vendor => (
//                                                     <option key={vendor.id} value={vendor.id}>{vendor.name}</option>
//                                                 ))}
//                                             </select>
//                                         </div>
//                                         <div className="col-md-2">
//                                             <label className="form-label small text-muted mb-1">Client</label>
//                                             <select
//                                                 name="client"
//                                                 value={filters.client}
//                                                 onChange={handleFilterChange}
//                                                 className="form-select form-select-sm"
//                                             >
//                                                 <option value="">All Clients</option>
//                                                 {filterOptions.clients.map(client => (
//                                                     <option key={client.id} value={client.id}>{client.name}</option>
//                                                 ))}
//                                             </select>
//                                         </div>
//                                         <div className="col-md-2">
//                                             <label className="form-label small text-muted mb-1">Category</label>
//                                             <select
//                                                 name="category"
//                                                 value={filters.category}
//                                                 onChange={handleFilterChange}
//                                                 className="form-select form-select-sm"
//                                             >
//                                                 <option value="">All Categories</option>
//                                                 {filterOptions.categories.map(category => (
//                                                     <option key={category.id} value={category.id}>{category.name}</option>
//                                                 ))}
//                                             </select>
//                                         </div>
//                                         <div className="col-md-2 d-flex flex-column justify-content-end gap-2">
//                                             <button
//                                                 onClick={applyFilters}
//                                                 className="btn btn-outline-primary btn-sm"
//                                             >
//                                                 <i className="mdi mdi-filter-outline me-2"></i> Apply Filters
//                                             </button>
//                                             <button
//                                                 onClick={clearFilters}
//                                                 className="btn btn-outline-secondary btn-sm"
//                                             >
//                                                 Clear
//                                             </button>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Rest of your component remains the same */}
//                     {/* Summary Cards */}
//                     <div className="row mb-4">
//                         <div className="col-md-4">
//                             <div className="card border-0 shadow-sm" style={{ backgroundColor: '#f8f9fa' }}>
//                                 <div className="card-body">
//                                     <div className="d-flex justify-content-between align-items-center">
//                                         <div>
//                                             <h6 className="text-muted mb-2">Total Expenses</h6>
//                                             <h3 className="mb-0" style={{ color: '#2e3a4d' }}>{formatCurrency(summary.grandTotal)}</h3>
//                                         </div>
//                                         <div className="bg-primary bg-opacity-10 p-3 rounded">
//                                             <i className="mdi mdi-cash-multiple text-primary" style={{ fontSize: '24px' }}></i>
//                                         </div>
//                                     </div>
//                                     <div className="mt-3">
//                                         <div className="d-flex justify-content-between">
//                                             <span className="text-muted small">Amount (excl. VAT)</span>
//                                             <span className="fw-medium">{formatCurrency(summary.totalAmount)}</span>
//                                         </div>
//                                         <div className="d-flex justify-content-between">
//                                             <span className="text-muted small">Adjustment Amount</span>
//                                             <span className="fw-medium">{formatCurrency(summary.adjustmentAmount)}</span>
//                                         </div>
//                                         <div className="d-flex justify-content-between">
//                                             <span className="text-muted small">VAT Amount</span>
//                                             <span className="fw-medium">{formatCurrency(summary.totalVAT)}</span>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>

//                         <div className="col-md-8">
//                             <div className="card border-0 shadow-sm">
//                                 <div className="card-body">
//                                     <h6 className="card-title mb-3" style={{ color: '#2e3a4d' }}>Payment Methods Breakdown</h6>
//                                     <div className="row">
//                                         <div className="col-md-4">
//                                             <div className="d-flex align-items-center mb-3">
//                                                 <div className="bg-primary bg-opacity-10 p-2 rounded me-3">
//                                                     <i className="mdi mdi-bank text-primary"></i>
//                                                 </div>
//                                                 <div>
//                                                     <p className="text-muted mb-0 small">Bank Transfer</p>
//                                                     <h5 className="mb-0">{formatCurrency(summary.paymentMethods.bank)}</h5>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                         <div className="col-md-4">
//                                             <div className="d-flex align-items-center mb-3">
//                                                 <div className="bg-success bg-opacity-10 p-2 rounded me-3">
//                                                     <i className="mdi mdi-cash text-success"></i>
//                                                 </div>
//                                                 <div>
//                                                     <p className="text-muted mb-0 small">Cash</p>
//                                                     <h5 className="mb-0">{formatCurrency(summary.paymentMethods.cash)}</h5>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                         <div className="col-md-4">
//                                             <div className="d-flex align-items-center mb-3">
//                                                 <div className="bg-secondary bg-opacity-10 p-2 rounded me-3">
//                                                     <i className="mdi mdi-wallet text-secondary"></i>
//                                                 </div>
//                                                 <div>
//                                                     <p className="text-muted mb-0 small">Unpaid</p>
//                                                     <h5 className="mb-0">{formatCurrency(summary.paymentMethods.other)}</h5>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Expense Table */}
//                     {/* ... rest of your table code remains exactly the same ... */}
//                     <div className="row">
//                         <div className="col-12">
//                             <div className="card border-0 shadow-sm">
//                                 <div className="card-body">
//                                     {expenses.length === 0 ? (
//                                         <div className="text-center py-5">
//                                             <i className="mdi mdi-file-document-outline text-muted" style={{ fontSize: '48px' }}></i>
//                                             <h5 className="mt-3" style={{ color: '#2e3a4d' }}>No expenses found</h5>
//                                             <p className="text-muted">Try adjusting your filters or add new expenses</p>
//                                         </div>
//                                     ) : (
//                                         <div className="table-responsive">
//                                             <table className="table align-middle table-nowrap table-check table-list">
//                                                 <thead className='table-sales-gradient'>
//                                                     <tr>
//                                                         <th style={{ width: '20px' }} className="align-middle">
//                                                             <div className="form-check font-size-16">
//                                                                 <input className="form-check-input" type="checkbox" id="checkAll" />
//                                                                 <label className="form-check-label" htmlFor="checkAll"></label>
//                                                             </div>
//                                                         </th>
//                                                         <th className="align-middle">#</th>
//                                                         <th className="border-0">Date</th>
//                                                         <th className="border-0">Description</th>
//                                                         <th className="border-0">Project</th>
//                                                         <th className="border-0">Vendor/Client</th>
//                                                         <th className="border-0">User</th>
//                                                         <th className="border-0 text-end">Amount</th>
//                                                         <th className="border-0 text-end">VAT(5%)</th>
//                                                         <th className="border-0 ">Adjustment Amount</th>
//                                                         <th className="border-0 text-end">Total</th>
//                                                         <th className="border-0">Payment</th>
//                                                         <th className="border-0">Tax</th>
//                                                     </tr>
//                                                 </thead>
//                                                 <tbody>
//                                                     {expenses.map((expense, index) => (
//                                                         <tr key={index} style={{ borderBottom: '1px solid #f1f3f9' }}>
//                                                             <td>
//                                                                 <div className="form-check font-size-16">
//                                                                     <input
//                                                                         className="form-check-input"
//                                                                         type="checkbox"
//                                                                         id={`transactionCheck${index}`}
//                                                                     />
//                                                                     <label
//                                                                         className="form-check-label"
//                                                                         htmlFor={`transactionCheck${index}`}
//                                                                     ></label>
//                                                                 </div>
//                                                             </td>
//                                                             <td>{index + 1}</td>

//                                                             <td
//                                                                 style={{ color: '#6c757d', cursor: 'pointer' }}
//                                                                 onClick={() => handleExpenseClick(expense)}
//                                                             >
//                                                                 {(expense.date)}
//                                                             </td>
//                                                             <td>
//                                                                 <span className="d-block fw-medium" style={{ color: '#2e3a4d' }}>
//                                                                     {expense.narration || ' '}
//                                                                 </span>
//                                                                 <small className="text-muted">{expense.type}</small>
//                                                             </td>
//                                                             <td>{expense.project || ''}</td>
//                                                             <td>{expense.vendor || expense.client || ''}</td>
//                                                             <td>{expense.user || ''}</td>
//                                                             <td className="text-end">{formatCurrency(expense.amount_excl_vat)}</td>
//                                                             <td className="text-end">
//                                                                 {expense.vat_percent > 0 ? (
//                                                                     <span className="text-success">
//                                                                         {formatCurrency(expense.vat_amount)}
//                                                                     </span>
//                                                                 ) : ''}
//                                                             </td>
//                                                             <td>{formatCurrency(expense.adjustment_amount || 0)}</td>
//                                                             <td className="text-end fw-medium" style={{ color: '#2e3a4d' }}>
//                                                                 {formatCurrency(expense.total)}
//                                                                                                                                           <span className="text-muted ms-1 font-size-11">
//                                                                                                                                 ({expense.vendor_currency})

//                                                 </span>
//                                                             </td>
//                                                             <td>
//                                                                 <span className={`badge ${expense.payment_mode === 'Bank' ? 'bg-primary' : expense.payment_mode === 'Cash' ? 'bg-success' : 'bg-secondary'}`}>
//                                                                     {expense.payment_mode}
//                                                                 </span>
//                                                             </td>
//                                                             <td>
//                                                                 <span className={`badge ${expense.tax_type === 'taxable' ? 'bg-info' : 'bg-light text-dark'}`}>
//                                                                     {expense.tax_type || 'N/A'}
//                                                                 </span>
//                                                             </td>
//                                                         </tr>
//                                                     ))}
//                                                 </tbody>
//                                                 <tfoot style={{ backgroundColor: '#f8f9fa' }}>
//                                                     <tr>
//                                                         <th colSpan="7" className="text-end">Totals:</th>
//                                                         <th className="text-end">{formatCurrency(summary.totalAmount)}</th>
//                                                         <th className="text-end">{formatCurrency(summary.totalVAT)}</th>
//                                                         <th>{formatCurrency(summary.adjustmentAmount)}</th>

//                                                         <th className="text-end">{formatCurrency(summary.grandTotal)}</th>
//                                                         <th colSpan="2"></th>
//                                                     </tr>
//                                                 </tfoot>
//                                             </table>
//                                         </div>
//                                     )}
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//            <Offcanvas
//                 show={showModal}
//                 onHide={() => setShowModal(false)}
//                 placement="end"
//                 style={{ width: '600px' }}
//             >
//                 <Offcanvas.Header closeButton className="border-bottom">
//                     <Offcanvas.Title className="text-primary">
//                         <i className="mdi mdi-receipt me-2"></i>
//                         Expense Details
//                     </Offcanvas.Title>
//                 </Offcanvas.Header>
//                 <Offcanvas.Body>
//                     {selectedExpense && (
//                         <div>
//                             {/* Expense Header Card */}
//                             <div className="card shadow-sm mb-4 border-0 bg-light">
//                                 <div className="card-body">
//                                     <div className="d-flex justify-content-between align-items-center mb-3">
//                                         <div>
//                                             <h6 className="text-muted mb-1">Expense Date</h6>
//                                             <p className="mb-0 fw-bold">{moment(selectedExpense.date).format('DD MMM YYYY')}</p>
//                                         </div>
//                                         <div className="text-end">
//                                             <h6 className="text-muted mb-1">Reference</h6>
//                                             <span className="badge bg-primary">{selectedExpense?.transaction?.reference || ''}</span>
//                                         </div>
//                                     </div>

//                                     <div className="mt-3">
//                                         <h6 className="text-muted mb-1">Description</h6>
//                                         <p className="mb-0 fw-semibold">{selectedExpense.narration || selectedExpense.description}</p>
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Basic Information */}
//                             <div className="row mb-4">
//                                 <div className="col-md-6">
//                                     <div className="card border-0 shadow-sm mb-3">
//                                         <div className="card-body">
//                                             <h6 className="text-muted mb-2">Basic Information</h6>
//                                             <div className="d-flex justify-content-between mb-2">
//                                                 <span className="small text-muted">
//                                                     {selectedExpense.vendor ? 'Vendor' : 'User'}
//                                                 </span>
//                                                 <span className="fw-medium">
//                                                     {selectedExpense.vendor ? selectedExpense.vendor : selectedExpense.user || ''}
//                                                 </span>
//                                             </div>


//                                             <div className="d-flex justify-content-between mb-2">
//                                                 <span className="small text-muted">Project:</span>
//                                                 <span className="fw-medium">{selectedExpense.project || ''}</span>
//                                             </div>
//                                             <div className="d-flex justify-content-between mb-2">
//                                                 <span className="small text-muted">Category:</span>
//                                                 <span className="fw-medium">{selectedExpense.category || ''}</span>
//                                             </div>
//                                             <div className="d-flex justify-content-between mb-2">
//                                                 <span className="small text-muted">Invoice No:</span>
//                                                 <span className="fw-medium">{selectedExpense.invoice_no || ''}</span>
//                                             </div>
//                                             {/* <div className="d-flex justify-content-between">
//                                                 <span className="small text-muted">Entered By:</span>
//                                                 <span className="fw-medium">{selectedExpense.user || 'N/A'}</span>
//                                             </div> */}
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div className="col-md-6">
//                                     <div className="card border-0 shadow-sm mb-3">
//                                         <div className="card-body">
//                                             <h6 className="text-muted mb-2">Financial Details</h6>
//                                             <div className="d-flex justify-content-between mb-2">
//                                                 <span className="small text-muted">Amount:</span>
//                                                 <span className="fw-medium">{formatCurrency(selectedExpense.amount_excl_vat)}
//                                                                                                                               <span className="text-muted ms-1 font-size-11">
//                                                                                                                                 {selectedExpense.vendor_currency}

//                                                 </span>
//                                                 </span>
//                                             </div>
//                                             <div className="d-flex justify-content-between mb-2">
//                                                 <span className="small text-muted">VAT ({selectedExpense.vat_percent || 0}%):</span>
//                                                 <span className="text-success">{formatCurrency(selectedExpense.vat_amount || 0)}</span>
//                                             </div>
//                                             <div className="d-flex justify-content-between mb-2">
//                                                 <span className="small text-muted">Adjustment Amount:</span>
//                                                 <span className="text-success">{formatCurrency(selectedExpense.adjustment_amount || 0)}</span>
//                                             </div>
//                                             <div className="d-flex justify-content-between mb-2">
//                                                 <span className="small text-muted">Total:</span>
//                                                 <span className="fw-bold text-primary">{formatCurrency(selectedExpense.total)}
//                                                                                                                             <span className="text-muted ms-1 font-size-11">
//                                                                                                                                 {selectedExpense.vendor_currency}

//                                                 </span>
//                                                 </span>
//                                             </div>
//                                             <div className="d-flex justify-content-between">
//                                                 <span className="small text-muted">Tax Type:</span>
//                                                 <span className={`badge ${selectedExpense.tax_type === 'taxable' ? 'bg-info' : 'bg-light text-dark'}`}>
//                                                     {selectedExpense.tax_type || 'N/A'}
//                                                 </span>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Payment Details */}
//                             <div className="card border-0 shadow-sm mb-4">
//                                 <div className="card-body">
//                                     <h6 className="text-muted mb-3">
//                                         <i className="mdi mdi-credit-card-outline me-1"></i>
//                                         Payment Details
//                                     </h6>

//                                     <div className="d-flex justify-content-between align-items-center mb-3">
//                                         <span className="fw-semibold">Payment Method:</span>
//                                         <span className={`badge ${selectedExpense.payment_mode === 'Bank' ? 'bg-primary' : selectedExpense.payment_mode === 'Cash' ? 'bg-success' : 'bg-secondary'}`}>
//                                             {selectedExpense.payment_mode}
//                                         </span>
//                                     </div>

//                                     {/* Bank Payment Details (if applicable) */}
//                                     {selectedExpense.payment_mode === 'Bank' && (
//                                         <div className="mt-3 p-3 bg-light rounded">
//                                             <h6 className="text-muted mb-2">Bank Transfer Details</h6>
//                                             <div className="d-flex justify-content-between mb-2">
//                                                 <span className="small text-muted">Bank Name:</span>
//                                                 <span className="fw-medium">{selectedExpense?.transaction?.account_name || ''}</span>
//                                             </div>
//                                             <div className="d-flex justify-content-between mb-2">
//                                                 <span className="small text-muted">Account Number:</span>
//                                                 <span className="fw-medium">{selectedExpense?.transaction?.account_number || ''}</span>
//                                             </div>
//                                             <div className="d-flex justify-content-between mb-2">
//                                                 <span className="small text-muted">Transaction Reference:</span>
//                                                 <span className="fw-medium">{selectedExpense.transaction?.reference || ''}</span>
//                                             </div>
//                                             <div className="d-flex justify-content-between">
//                                                 <span className="small text-muted">Transfer Date:</span>
//                                                 <span className="fw-medium">{selectedExpense?.transaction?.transaction_date ? moment(selectedExpense.transfer_date).format('DD MMM YYYY') : 'N/A'}</span>
//                                             </div>
//                                         </div>
//                                     )}

//                                     {/* Cash Payment Details (if applicable) */}
//                                     {selectedExpense.payment_mode === 'Cash' && (
//                                         <div className="mt-3 p-3 bg-light rounded">
//                                             <h6 className="text-muted mb-2"> Transfer Details</h6>
//                                             <div className="d-flex justify-content-between mb-2">
//                                                 <span className="small text-muted">Account Name:</span>
//                                                 <span className="fw-medium">{selectedExpense?.transaction?.account_name || ''}</span>
//                                             </div>


//                                             <div className="d-flex justify-content-between">
//                                                 <span className="small text-muted">Transfer Date:</span>
//                                                 <span className="fw-medium">{selectedExpense?.transaction?.transaction_date ? moment(selectedExpense.transfer_date).format('DD MMM YYYY') : 'N/A'}</span>
//                                             </div>
//                                         </div>
//                                     )}

//                                     {/* Other Payment Details */}
//                                     {selectedExpense.payment_mode !== 'Bank' && selectedExpense.payment_mode !== 'Cash' && (
//                                         <div className="mt-3 p-3 bg-light rounded">
//                                             <h6 className="text-muted mb-2">Not paid via Bank or Cash</h6>
//                                             <p className="mb-0 small">Paid using {selectedExpense.payment_mode} method.</p>
//                                         </div>
//                                     )}
//                                 </div>
//                             </div>

//                             {/* Additional Information */}
//                             {selectedExpense.notes && (
//                                 <div className="card border-0 shadow-sm">
//                                     <div className="card-body">
//                                         <h6 className="text-muted mb-2">Additional Notes</h6>
//                                         <p className="mb-0">{selectedExpense.notes}</p>
//                                     </div>
//                                 </div>
//                             )}
//                         </div>
//                     )}
//                 </Offcanvas.Body>
//             </Offcanvas>
//         </div>
//     );
// };

// export default ExpenseReport;

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import moment from 'moment';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";
import Select from "react-select";


const ExpenseReport = () => {
    const [expenses, setExpenses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filters, setFilters] = useState({
        dateRange: 'this_month',
        fromDate: '',
        toDate: '',
        project: '',
        vendor: '',
        client: '',
        category: '',
        paymentStatus: '',
        source: []
    });
    const [filterOptions, setFilterOptions] = useState({
        projects: [],
        vendors: [],
        clients: [],
        categories: []
    });
    const [summary, setSummary] = useState({
        totalAmount: 0,
        totalVAT: 0,
        grandTotal: 0,
        adjustmentAmount: 0,
        totalAmountAED: 0,
        totalVATAED: 0,
        grandTotalAED: 0,
        adjustmentAmountAED: 0,
        paymentMethods: {
            cash: 0,
            bank: 0,
            other: 0
        },
        paymentMethodsAED: {
            cash: 0,
            bank: 0,
            other: 0
        },
        totalWpsCharge: 0,
        totalWpsVat: 0,
        totalWpsChargeAED: 0,
        totalWpsVatAED: 0
    });
    const [selectedExpense, setSelectedExpense] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    const userInfo = JSON.parse(localStorage.getItem("user-info"));
    const token = userInfo?.token;
    const origin = localStorage.getItem("user-origin");

    // Exchange rate constant
    const EXCHANGE_RATE = 3.692;

    useEffect(() => {
        fetchData();
        fetchFilterOptions();
    }, [filters.dateRange]);

    const fetchData = async () => {
        try {
            setLoading(true);
            const params = { ...filters };
            if (Array.isArray(params.source) && params.source.length > 0) {
                params.source = params.source.join(',');
            } else if (!params.source || params.source.length === 0) {
                delete params.source;
            }

            const response = await axios.get(`${backendUrl}/api/expense-report`, {
                params: params,
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Tenant-Origin": origin,
                }
            });

            const data = response.data.data || [];
            // Add AED conversions to each expense
            const dataWithAED = data.map(expense => ({
                ...expense,
                amount_aed: convertToAED(expense.amount_excl_vat, expense.vendor_currency),
                vat_amount_aed: convertToAED(expense.vat_amount, expense.vendor_currency),
                adjustment_amount_aed: convertToAED(expense.adjustment_amount || 0, expense.vendor_currency),
                total_aed: convertToAED(expense.total, expense.vendor_currency),
                paid_amount_aed: convertToAED(expense.paid_amount || 0, expense.vendor_currency),
                balance_amount_aed: convertToAED(expense.balance_amount || 0, expense.vendor_currency),
                wps_charge_aed: convertToAED(expense.wps_charge || 0, expense.vendor_currency),
                wps_vat_aed: convertToAED(expense.wps_vat || 0, expense.vendor_currency)
            }));

            setExpenses(dataWithAED);
            calculateSummary(dataWithAED);
        } catch (error) {
            console.error("Error loading expense report:", error);
        } finally {
            setLoading(false);
        }
    };

    // Function to convert amount to AED
    const convertToAED = (amount, currency) => {
        const numericAmount = parseFloat(amount) || 0;
        if (currency === 'USD') {
            return numericAmount * EXCHANGE_RATE;
        }
        return numericAmount; // Assuming AED is default
    };

    const fetchFilterOptions = async () => {
        try {
            const response = await axios.get(`${backendUrl}/api/expense-report/filter-options`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Tenant-Origin": origin,
                }
            });
            setFilterOptions(response.data);
        } catch (error) {
            console.error("Error loading filter options:", error);
        }
    };

    const calculateSummary = (data) => {
        let totalAmount = 0;
        let totalVAT = 0;
        let adjustmentAmount = 0;
        let totalAmountAED = 0;
        let totalVATAED = 0;
        let adjustmentAmountAED = 0;
        let totalWpsCharge = 0;
        let totalWpsVat = 0;
        let totalWpsChargeAED = 0;
        let totalWpsVatAED = 0;
        let paymentMethods = {
            cash: 0,
            bank: 0,
            other: 0 // This will now represent "Unpaid" / Balance
        };
        let paymentMethodsAED = {
            cash: 0,
            bank: 0,
            other: 0 // This will now represent "Unpaid" / Balance
        };

        data.forEach(expense => {
            const amount = parseFloat(expense.amount_excl_vat);
            const vat = parseFloat(expense.vat_amount);
            const adjustment = parseFloat(expense.adjustment_amount || 0);
            const total = parseFloat(expense.total);

            const paid = parseFloat(expense.paid_amount || 0);
            const balance = parseFloat(expense.balance_amount || 0);

            const amountAED = parseFloat(expense.amount_aed);
            const vatAED = parseFloat(expense.vat_amount_aed);
            const adjustmentAED = parseFloat(expense.adjustment_amount_aed);
            const totalAED = parseFloat(expense.total_aed);

            const paidAED = parseFloat(expense.paid_amount_aed || 0);
            const balanceAED = parseFloat(expense.balance_amount_aed || 0);
            const wpsCharge = parseFloat(expense.wps_charge || 0);
            const wpsVat = parseFloat(expense.wps_vat || 0);
            const wpsChargeAED = parseFloat(expense.wps_charge_aed || 0);
            const wpsVatAED = parseFloat(expense.wps_vat_aed || 0);

            totalAmount += amount;
            totalVAT += vat;
            adjustmentAmount += adjustment;

            totalAmountAED += amountAED;
            totalVATAED += vatAED;
            adjustmentAmountAED += adjustmentAED;
            totalWpsCharge += wpsCharge;
            totalWpsVat += wpsVat;
            totalWpsChargeAED += wpsChargeAED;
            totalWpsVatAED += wpsVatAED;

            // Add balance to "Unpaid" (other)
            paymentMethods.other += balance;
            paymentMethodsAED.other += balanceAED;

            // Add paid amount to relevant mode
            if (expense.payment_mode === 'Cash') {
                paymentMethods.cash += paid;
                paymentMethodsAED.cash += paidAED;
            } else if (expense.payment_mode === 'Bank') {
                paymentMethods.bank += paid;
                paymentMethodsAED.bank += paidAED;
            }
            // If payment_mode is 'Other' or 'Unpaid' but there is a paid amount (rare case for Unpaid, but possible for Other),
            // we could add it to a catch-all or just ignore if we strictly want Bank vs Cash vs Unpaid.
            // Assuming 'Other' payment mode might exist for non-bank/cash payments:
            else if (expense.payment_mode !== 'Unpaid' && paid > 0) {
                // For now, let's just group "Other" paid amounts into Cash or ignore? 
                // The UI only has Bank, Cash, Unpaid. 
                // Let's add it to Cash for now or create a new category if needed, but the UI is fixed.
                // Actually, let's just leave it out of Bank/Cash stats if it's strictly those two.
            }
        });

        setSummary({
            totalAmount,
            totalVAT,
            adjustmentAmount,
            grandTotal: totalAmount + totalVAT + adjustmentAmount + totalWpsCharge + totalWpsVat,
            totalAmountAED,
            totalVATAED,
            adjustmentAmountAED,
            grandTotalAED: totalAmountAED + totalVATAED + adjustmentAmountAED + totalWpsChargeAED + totalWpsVatAED,
            paymentMethods,
            paymentMethodsAED,
            totalWpsCharge,
            totalWpsVat,
            totalWpsChargeAED,
            totalWpsVatAED
        });
    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;

        // If date range is selected, clear custom dates
        if (name === 'dateRange' && value !== 'custom') {
            setFilters(prev => ({
                ...prev,
                [name]: value,
                fromDate: '',
                toDate: ''
            }));
        } else {
            setFilters(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleExpenseClick = (expense) => {
        setSelectedExpense(expense);
        setShowModal(true);
    };

    const exportToExcel = async () => {
        try {
            const response = await axios.get(`${backendUrl}/api/expense-report/export`, {
                params: filters,
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Tenant-Origin": origin,
                },
                responseType: 'blob',
            });

            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            saveAs(blob, `Expense_Report_${moment().format('YYYYMMDD')}.xlsx`);
        } catch (error) {
            console.error("Error exporting expense report:", error);
        }
    };

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-AE', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(amount);
    };

    const clearFilters = () => {
        setFilters({
            dateRange: 'this_month',
            fromDate: '',
            toDate: '',
            project: '',
            vendor: '',
            client: '',
            category: '',
            paymentStatus: '',
            source: []
        });
        // Don't fetch data immediately, wait for user to click Apply Filters
    };

    // Function to handle applying filters
    const applyFilters = () => {
        fetchData();
    };
    return (
        <div className="main-content" style={{ backgroundColor: '#f8f9fa' }}>
            <div className="page-content">
                <div className="container-fluid">
                    {/* Header Section */}
                    <div className="row mb-4">
                        <div className="col-12">
                            <div className="d-flex justify-content-between align-items-center">
                                <div>
                                    <h4 className="mb-0" style={{ color: '#2e3a4d', fontWeight: 600 }}>Expense Report</h4>

                                </div>
                                <button
                                    onClick={exportToExcel}
                                    className="btn btn-success"
                                    style={{
                                        backgroundColor: '#00a859',
                                        borderColor: '#00a859',
                                        borderRadius: '4px',
                                        padding: '8px 16px'
                                    }}
                                >
                                    <i className="mdi mdi-file-excel-outline me-2"></i> Export to Excel
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Filter Section - Same as before */}
                    {/* Filter Section */}
                    <div className="row mb-4">
                        <div className="col-12">
                            <div className="card border-0 shadow-sm">
                                <div className="card-body p-3">
                                    <div className="row g-3">
                                        <div className="col-md-2">
                                            <label className="form-label small text-muted mb-1">Date Range</label>
                                            <select
                                                name="dateRange"
                                                value={filters.dateRange}
                                                onChange={handleFilterChange}
                                                className="form-select form-select-sm"
                                            >
                                                <option value="this_month">This Month</option>
                                                <option value="last_month">Last Month</option>
                                                <option value="this_quarter">This Quarter</option>
                                                <option value="last_quarter">Last Quarter</option>
                                                <option value="this_year">This Year</option>
                                                <option value="custom">Custom Date Range</option>
                                            </select>
                                        </div>

                                        {/* Custom Date Range Fields - Only show when "Custom" is selected */}
                                        {filters.dateRange === 'custom' && (
                                            <>
                                                {/* <div className="col-md-2">
                                                    <label className="form-label small text-muted mb-1">From Date</label>
                                                    <input
                                                        type="date"
                                                        name="fromDate"
                                                        value={filters.fromDate}
                                                        onChange={handleFilterChange}
                                                        className="form-control form-control-sm"
                                                    />
                                                </div> */}
                                                <div className="col-md-2">
                                                    <label className="form-label small text-muted mb-1">From Date</label>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker
                                                            views={["year", "month", "day"]}
                                                            format="DD-MM-YYYY"
                                                            value={filters.fromDate ? dayjs(filters.fromDate) : null}
                                                            onChange={(newValue) => {
                                                                setFilters(prev => ({
                                                                    ...prev,
                                                                    fromDate: newValue ? newValue.format("YYYY-MM-DD") : ""
                                                                }));
                                                            }}
                                                            slotProps={{
                                                                textField: {
                                                                    size: "small",
                                                                    fullWidth: true,
                                                                    variant: "outlined",
                                                                    inputProps: {
                                                                        style: { fontSize: '11px', padding: '6px 12px' }
                                                                    }
                                                                },
                                                            }}
                                                        />
                                                    </LocalizationProvider>
                                                </div>
                                                <div className="col-md-2">
                                                    <label className="form-label small text-muted mb-1">To Date</label>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker
                                                            views={["year", "month", "day"]}
                                                            format="DD-MM-YYYY"
                                                            value={filters.toDate ? dayjs(filters.toDate) : null}
                                                            onChange={(newValue) => {
                                                                setFilters(prev => ({
                                                                    ...prev,
                                                                    toDate: newValue ? newValue.format("YYYY-MM-DD") : ""
                                                                }));
                                                            }}
                                                            slotProps={{
                                                                textField: {
                                                                    size: "small",
                                                                    fullWidth: true,
                                                                    variant: "outlined",
                                                                    inputProps: {
                                                                        style: { fontSize: '11px', padding: '6px 12px' }
                                                                    }
                                                                },
                                                            }}
                                                        />
                                                    </LocalizationProvider>
                                                </div>

                                            </>
                                        )}

                                        {/* <div className="col-md-2">
                                            <label className="form-label small text-muted mb-1">Project</label>
                                            <select
                                                name="project"
                                                value={filters.project}
                                                onChange={handleFilterChange}
                                                className="form-select form-select-sm"
                                            >
                                                <option value="">All Projects</option>
                                                {filterOptions.projects.map(project => (
                                                    <option key={project.id} value={project.id}>{project.name}</option>
                                                ))}
                                            </select>
                                        </div> */}
                                        <div className="col-md-2">
                                            <label className="form-label small text-muted mb-1">Vendor</label>
                                            <select
                                                name="vendor"
                                                value={filters.vendor}
                                                onChange={handleFilterChange}
                                                className="form-select form-select-sm"
                                            >
                                                <option value="">All Vendors</option>
                                                {filterOptions.vendors.map(vendor => (
                                                    <option key={vendor.id} value={vendor.id}>{vendor.name}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-md-2">
                                            <label className="form-label small text-muted mb-1">Client</label>
                                            <select
                                                name="client"
                                                value={filters.client}
                                                onChange={handleFilterChange}
                                                className="form-select form-select-sm"
                                            >
                                                <option value="">All Clients</option>
                                                {filterOptions.clients.map(client => (
                                                    <option key={client.id} value={client.id}>{client.name}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-md-2">
                                            <label className="form-label small text-muted mb-1">Category</label>
                                            <select
                                                name="category"
                                                value={filters.category}
                                                onChange={handleFilterChange}
                                                className="form-select form-select-sm"
                                            >
                                                <option value="">All Categories</option>
                                                {filterOptions.categories.map(category => (
                                                    <option key={category.id} value={category.id}>{category.name}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-md-2">
                                            <label className="form-label small text-muted mb-1">Payment Status</label>
                                            <select
                                                name="paymentStatus"
                                                value={filters.paymentStatus}
                                                onChange={handleFilterChange}
                                                className="form-select form-select-sm"
                                            >
                                                <option value="">All Status</option>
                                                <option value="Paid">Paid</option>
                                                <option value="Partial">Partial</option>
                                                <option value="Unpaid">Unpaid</option>
                                            </select>
                                        </div>
                                        <div className="col-md-2">
                                            <label className="form-label small text-muted mb-1">Expense Type</label>
                                            <Select
                                                isMulti
                                                options={[
                                                    { value: 'direct', label: 'Direct' },
                                                    { value: 'pettycash', label: 'Petty Cash' },
                                                    { value: 'salary', label: 'Salary' }
                                                ]}
                                                value={[
                                                    { value: 'direct', label: 'Direct' },
                                                    { value: 'pettycash', label: 'Petty Cash' },
                                                    { value: 'salary', label: 'Salary' }
                                                ].filter(option => filters.source.includes(option.value))}
                                                onChange={(selectedOptions) => {
                                                    setFilters(prev => ({
                                                        ...prev,
                                                        source: selectedOptions ? selectedOptions.map(option => option.value) : []
                                                    }));
                                                }}
                                                styles={{
                                                    control: (base) => ({
                                                        ...base,
                                                        minHeight: '31px',
                                                        fontSize: '11px',
                                                        borderColor: '#ced4da',
                                                        boxShadow: 'none',
                                                        '&:hover': { borderColor: '#b3b3b3' }
                                                    }),
                                                    menu: (base) => ({
                                                        ...base,
                                                        zIndex: 9999,
                                                        fontSize: '11px'
                                                    }),
                                                    valueContainer: (base) => ({
                                                        ...base,
                                                        padding: '0px 8px',
                                                    }),
                                                    indicatorsContainer: (base) => ({
                                                        ...base,
                                                        height: '31px'
                                                    }),
                                                    multiValue: (base) => ({
                                                        ...base,
                                                        backgroundColor: '#e9ecef',
                                                        margin: '1px'
                                                    }),
                                                    multiValueLabel: (base) => ({
                                                        ...base,
                                                        fontSize: '10px',
                                                        padding: '1px 4px',
                                                        color: '#495057'
                                                    })
                                                }}
                                                placeholder="Select Type..."
                                                className="react-select-container"
                                                classNamePrefix="react-select"
                                            />
                                        </div>
                                        <div className="col-md-2 d-flex flex-column justify-content-end gap-2">
                                            <button
                                                onClick={applyFilters}
                                                className="btn btn-outline-primary btn-sm"
                                            >
                                                <i className="mdi mdi-filter-outline me-2"></i> Apply Filters
                                            </button>
                                            <button
                                                onClick={clearFilters}
                                                className="btn btn-outline-secondary btn-sm"
                                            >
                                                Clear
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Summary Cards - Update to show AED totals */}
                    {/* <div className="row mb-4">
                        <div className="col-md-4">
                            <div className="card border-0 shadow-sm" style={{ backgroundColor: '#f8f9fa' }}>
                                <div className="card-body">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div>
                                            <h6 className="text-muted mb-2">Total Expenses</h6>
                                            <h3 className="mb-0" style={{ color: '#2e3a4d' }}>{formatCurrency(summary.grandTotalAED)} AED</h3>
                                           
                                        </div>
                                        <div className="bg-primary bg-opacity-10 p-3 rounded">
                                            <i className="mdi mdi-cash-multiple text-primary" style={{ fontSize: '24px' }}></i>
                                        </div>
                                    </div>
                                    <div className="mt-3">
                                        <div className="d-flex justify-content-between">
                                            <span className="text-muted small">Amount (excl. VAT)</span>
                                            <div className="text-end">
                                                <div>{formatCurrency(summary.totalAmountAED)} AED</div>
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <span className="text-muted small">Adjustment Amount</span>
                                            <div className="text-end">
                                                <div>{formatCurrency(summary.adjustmentAmountAED)} AED</div>
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <span className="text-muted small">VAT Amount</span>
                                            <div className="text-end">
                                                <div>{formatCurrency(summary.totalVATAED)} AED</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-8">
                            <div className="card border-0 shadow-sm">
                                <div className="card-body">
                                    <h6 className="card-title mb-3" style={{ color: '#2e3a4d' }}>Payment Methods Breakdown (AED)</h6>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="d-flex align-items-center mb-3">
                                                <div className="bg-primary bg-opacity-10 p-2 rounded me-3">
                                                    <i className="mdi mdi-bank text-primary"></i>
                                                </div>
                                                <div>
                                                    <p className="text-muted mb-0 small">Bank Transfer</p>
                                                    <h5 className="mb-0">{formatCurrency(summary.paymentMethodsAED.bank)} AED</h5>
                                                  
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="d-flex align-items-center mb-3">
                                                <div className="bg-success bg-opacity-10 p-2 rounded me-3">
                                                    <i className="mdi mdi-cash text-success"></i>
                                                </div>
                                                <div>
                                                    <p className="text-muted mb-0 small">Cash</p>
                                                    <h5 className="mb-0">{formatCurrency(summary.paymentMethodsAED.cash)} AED</h5>
                                                  
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="d-flex align-items-center mb-3">
                                                <div className="bg-secondary bg-opacity-10 p-2 rounded me-3">
                                                    <i className="mdi mdi-wallet text-secondary"></i>
                                                </div>
                                                <div>
                                                    <p className="text-muted mb-0 small">Unpaid</p>
                                                    <h5 className="mb-0">{formatCurrency(summary.paymentMethodsAED.other)} AED</h5>
                                                 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    {/* Summary Cards */}
                    <div className="row mb-4">
                        <div className="col-md-4">
                            <div className="card border-0 shadow-sm" style={{ backgroundColor: '#f8f9fa' }}>
                                <div className="card-body">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div>
                                            <h6 className="text-muted mb-2">Total Expenses</h6>
                                            <h3 className="mb-0" style={{ color: '#2e3a4d' }}>
                                                {formatCurrency(summary.grandTotalAED)} AED
                                            </h3>

                                        </div>

                                    </div>
                                    <div className="mt-3">
                                        <div className="d-flex justify-content-between">
                                            <span className="text-muted small">Amount (excl. VAT)</span>
                                            <div className="text-end">
                                                <div>{formatCurrency(summary.totalAmountAED)} AED</div>
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <span className="text-muted small">Adjustment Amount</span>
                                            <div className="text-end">
                                                <div>{formatCurrency(summary.adjustmentAmountAED)} AED</div>
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <span className="text-muted small">VAT Amount</span>
                                            <div className="text-end">
                                                <div>{formatCurrency(summary.totalVATAED)} AED</div>
                                            </div>
                                        </div>
                                        {(summary.totalWpsChargeAED > 0 || summary.totalWpsVatAED > 0) && (
                                            <>
                                                <div className="d-flex justify-content-between mt-1 pt-1 border-top">
                                                    <span className="text-muted small">WPS Charge</span>
                                                    <div className="text-end">
                                                        <div>{formatCurrency(summary.totalWpsChargeAED)} AED</div>
                                                    </div>
                                                </div>
                                                <div className="d-flex justify-content-between">
                                                    <span className="text-muted small">WPS VAT</span>
                                                    <div className="text-end">
                                                        <div>{formatCurrency(summary.totalWpsVatAED)} AED</div>
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-8">
                            <div className="card border-0 shadow-sm">
                                <div className="card-body">
                                    {/* Total Payment - Bank + Cash + Unpaid */}
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <h6 className="text-muted mb-2">Total Payment</h6>
                                            <h3 className="mb-0" style={{ color: '#2e3a4d' }}>
                                                {formatCurrency(
                                                    summary.paymentMethodsAED.bank +
                                                    summary.paymentMethodsAED.cash +
                                                    summary.paymentMethodsAED.other
                                                )} AED
                                            </h3>

                                        </div>
                                    </div>

                                    {/* Payment Methods Breakdown */}
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="d-flex align-items-center mb-3">
                                                <div className="bg-light bg-opacity-10 p-2 rounded me-3">
                                                    <i className="mdi mdi-bank text-black"></i>
                                                </div>
                                                <div>
                                                    <p className="text-muted mb-0 small">Bank Transfer</p>
                                                    <h5 className="mb-0">{formatCurrency(summary.paymentMethodsAED.bank)} AED</h5>
                                                    <small className="text-muted">
                                                        {((summary.paymentMethodsAED.bank /
                                                            (summary.paymentMethodsAED.bank +
                                                                summary.paymentMethodsAED.cash +
                                                                summary.paymentMethodsAED.other || 1)) * 100).toFixed(1)}%
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="d-flex align-items-center mb-3">
                                                <div className="bg-success bg-opacity-10 p-2 rounded me-3">
                                                    <i className="mdi mdi-cash text-success"></i>
                                                </div>
                                                <div>
                                                    <p className="text-muted mb-0 small">Cash</p>
                                                    <h5 className="mb-0">{formatCurrency(summary.paymentMethodsAED.cash)} AED</h5>
                                                    <small className="text-muted">
                                                        {((summary.paymentMethodsAED.cash /
                                                            (summary.paymentMethodsAED.bank +
                                                                summary.paymentMethodsAED.cash +
                                                                summary.paymentMethodsAED.other || 1)) * 100).toFixed(1)}%
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="d-flex align-items-center mb-3">
                                                <div className="bg-secondary bg-opacity-10 p-2 rounded me-3">
                                                    <i className="mdi mdi-wallet text-secondary"></i>
                                                </div>
                                                <div>
                                                    <p className="text-muted mb-0 small">Unpaid</p>
                                                    <h5 className="mb-0">{formatCurrency(summary.paymentMethodsAED.other)} AED</h5>
                                                    <small className="text-muted">
                                                        {((summary.paymentMethodsAED.other /
                                                            (summary.paymentMethodsAED.bank +
                                                                summary.paymentMethodsAED.cash +
                                                                summary.paymentMethodsAED.other || 1)) * 100).toFixed(1)}%
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Expense Table - Updated with AED columns */}
                    <div className="row">
                        <div className="col-12">
                            <div className="card border-0 shadow-sm">
                                <div className="card-body">
                                    {expenses.length === 0 ? (
                                        <div className="text-center py-5">
                                            <i className="mdi mdi-file-document-outline text-muted" style={{ fontSize: '48px' }}></i>
                                            <h5 className="mt-3" style={{ color: '#2e3a4d' }}>No expenses found</h5>
                                            <p className="text-muted">Try adjusting your filters or add new expenses</p>
                                        </div>
                                    ) : (
                                        <div className="table-responsive">
                                            <table className="table align-middle table-nowrap table-check table-list">
                                                <thead className='table-sales-gradient'>
                                                    <tr>
                                                        <th style={{ width: '20px' }} className="align-middle">
                                                            <div className="form-check font-size-16">
                                                                <input className="form-check-input" type="checkbox" id="checkAll" />
                                                                <label className="form-check-label" htmlFor="checkAll"></label>
                                                            </div>
                                                        </th>
                                                        <th className="align-middle">#</th>
                                                        <th className="border-0">Date</th>
                                                        <th className="border-0">Description</th>
                                                        <th className="border-0">Project</th>
                                                        <th className="border-0">Vendor/Client</th>
                                                        <th className="border-0">User</th>
                                                        <th className="border-0 text-end">Amount</th>
                                                        <th className="border-0 text-end">Amount (AED)</th>
                                                        <th className="border-0 text-end">VAT(5%)</th>
                                                        <th className="border-0 text-end">VAT (AED)</th>
                                                        <th className="border-0">Adjustment</th>
                                                        <th className="border-0">Adjustment (AED)</th>
                                                        <th className="border-0 text-end">Total</th>
                                                        <th className="border-0 text-end">Total (AED)</th>
                                                        <th className="border-0 text-end">Paid Amount</th>
                                                        <th className="border-0 text-end">Balance</th>
                                                        <th className="border-0">Payment</th>
                                                        {/* <th className="border-0">Tax</th> */}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {expenses.map((expense, index) => (
                                                        <tr key={index} style={{ borderBottom: '1px solid #f1f3f9' }}>
                                                            <td>
                                                                <div className="form-check font-size-16">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id={`transactionCheck${index}`}
                                                                    />
                                                                    <label
                                                                        className="form-check-label"
                                                                        htmlFor={`transactionCheck${index}`}
                                                                    ></label>
                                                                </div>
                                                            </td>
                                                            <td>{index + 1}</td>

                                                            <td
                                                                style={{ color: '#6c757d', cursor: 'pointer' }}
                                                                onClick={() => handleExpenseClick(expense)}
                                                            >
                                                                {(expense.date)}
                                                            </td>
                                                            <td>
                                                                <span
                                                                    className="d-block fw-medium text-truncate"
                                                                    style={{ color: '#2e3a4d', maxWidth: '100px' }}
                                                                    title={expense.narration}
                                                                >
                                                                    {expense.narration && expense.narration.length > 10
                                                                        ? expense.narration.substring(0, 10) + '...'
                                                                        : (expense.narration || ' ')}
                                                                </span>
                                                                {/* <small className="text-muted">{expense.type}</small> */}
                                                            </td>
                                                            <td title={expense.project}>
                                                                <div className="text-truncate" style={{ maxWidth: '120px' }}>
                                                                    {expense.project || ''}
                                                                </div>
                                                            </td>
                                                            <td title={expense.vendor || expense.client}>
                                                                <div className="text-truncate" style={{ maxWidth: '120px' }}>
                                                                    {expense.vendor || expense.client || ''}
                                                                </div>
                                                            </td>
                                                            <td>{expense.user || ''}</td>
                                                            <td className="text-end">
                                                                {formatCurrency(expense.amount_excl_vat)}
                                                                {/* <div className="text-muted small">
                                                                    {expense.vendor_currency}
                                                                </div> */}
                                                            </td>
                                                            <td className="text-end fw-medium">
                                                                {formatCurrency(expense.amount_aed)}
                                                                {/* <div className="text-muted small">AED</div> */}
                                                            </td>
                                                            <td className="text-end">
                                                                {expense.tax_type === 'taxable' ? (
                                                                    <span className="text-success">
                                                                        {formatCurrency(expense.vat_amount)}
                                                                        {/* <div className="text-muted small">
                                                                            {expense.vendor_currency}
                                                                        </div> */}
                                                                    </span>
                                                                ) : ''}
                                                            </td>
                                                            <td className="text-end">
                                                                {expense.vat_percent > 0 ? (
                                                                    <span className="text-success">
                                                                        {formatCurrency(expense.vat_amount_aed)}
                                                                        {/* <div className="text-muted small">AED</div> */}
                                                                    </span>
                                                                ) : ''}
                                                            </td>
                                                            <td>
                                                                {formatCurrency(expense.adjustment_amount || 0)}
                                                                {/* <div className="text-muted small">
                                                                    {expense.vendor_currency}
                                                                </div> */}
                                                            </td>
                                                            <td>
                                                                {formatCurrency(expense.adjustment_amount_aed || 0)}
                                                                {/* <div className="text-muted small">AED</div> */}
                                                            </td>
                                                            <td className="text-end fw-medium" style={{ color: '#2e3a4d' }}>
                                                                {formatCurrency(expense.total)}
                                                                {/* <div className="text-muted small">
                                                                    {expense.vendor_currency}
                                                                </div> */}
                                                            </td>
                                                            <td className="text-end fw-bold" style={{ color: '#00a859' }}>
                                                                {formatCurrency(expense.total_aed)}
                                                                {/* <div className="text-muted small">AED</div> */}
                                                            </td>
                                                            <td className="text-end text-success">
                                                                {formatCurrency(expense.paid_amount || 0)}
                                                                {/* <div className="text-muted small">
                                                                    {expense.vendor_currency}
                                                                </div> */}
                                                            </td>
                                                            <td className="text-end text-danger">
                                                                {formatCurrency(expense.balance_amount || 0)}
                                                                {/* <div className="text-muted small">
                                                                    {expense.vendor_currency}
                                                                </div> */}
                                                            </td>
                                                            <td>
                                                                <span className={`badge ${expense.payment_status === 'Paid' ? 'bg-success' :
                                                                    expense.payment_status === 'Partial' ? 'bg-warning' :
                                                                        'bg-danger'
                                                                    }`}>
                                                                    {expense.payment_status}
                                                                </span>
                                                                {/* <div className="small text-muted mt-1">{expense.payment_mode}</div> */}
                                                            </td>
                                                            {/* <td>
                                                                <span className={`badge ${expense.tax_type === 'taxable' ? 'bg-info' : 'bg-light text-dark'}`}>
                                                                    {expense.tax_type || 'N/A'}
                                                                </span>
                                                            </td> */}
                                                        </tr>
                                                    ))}
                                                </tbody>
                                                <tfoot style={{ backgroundColor: '#f8f9fa' }}>
                                                    <tr>
                                                        <th colSpan="7" className="text-end">Totals:</th>
                                                        <th className="text-end"></th>
                                                        <th className="text-end"></th>
                                                        <th className="text-end"></th>
                                                        <th className="text-end"></th>
                                                        <th className="text-end"></th>
                                                        <th className="text-end"></th>
                                                        <th className="text-end"></th>
                                                        <th className="text-end fw-bold" style={{ color: '#00a859' }}>
                                                            {formatCurrency(summary.grandTotalAED)} AED
                                                        </th>
                                                        <th colSpan="2"></th>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Offcanvas
                show={showModal}
                onHide={() => setShowModal(false)}
                placement="end"
                style={{ width: '600px' }}
            >
                <Offcanvas.Header closeButton className="border-bottom">
                    <Offcanvas.Title className="text-primary">
                        <i className="mdi mdi-receipt me-2"></i>
                        Expense Details
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    {selectedExpense && (
                        <div>
                            {/* Expense Header Card */}
                            <div className="card shadow-sm mb-4 border-0 bg-light">
                                <div className="card-body">
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <div>
                                            <h6 className="text-muted mb-1">Expense Date</h6>
                                            <p className="mb-0 fw-bold">{moment(selectedExpense.date).format('DD MMM YYYY')}</p>
                                        </div>
                                        <div className="text-end">
                                            <h6 className="text-muted mb-1">Reference</h6>
                                            <span className="badge bg-primary">{selectedExpense?.transaction?.reference || ''}</span>
                                        </div>
                                    </div>

                                    <div className="mt-3">
                                        <h6 className="text-muted mb-1">Description</h6>
                                        <p className="mb-0 fw-semibold">{selectedExpense.narration || selectedExpense.description}</p>
                                    </div>
                                </div>
                            </div>

                            {/* Basic Information */}
                            <div className="row mb-4">
                                <div className="col-md-12">
                                    <div className="card border-0 shadow-sm mb-3">
                                        <div className="card-body">
                                            <h6 className="text-muted mb-2">Basic Information</h6>
                                            <div className="d-flex justify-content-between mb-2">
                                                <span className="small text-muted">
                                                    {selectedExpense.vendor ? 'Vendor' : 'User'}
                                                </span>
                                                <span className="fw-medium">
                                                    {selectedExpense.vendor ? selectedExpense.vendor : selectedExpense.user || ''}
                                                </span>
                                            </div>


                                            <div className="d-flex justify-content-between mb-2">
                                                <span className="small text-muted">Project:</span>
                                                <span className="fw-medium">{selectedExpense.project || ''}</span>
                                            </div>
                                            <div className="d-flex justify-content-between mb-2">
                                                <span className="small text-muted">Category:</span>
                                                <span className="fw-medium">{selectedExpense.category || ''}</span>
                                            </div>
                                            <div className="d-flex justify-content-between mb-2">
                                                <span className="small text-muted">Invoice No:</span>
                                                <span className="fw-medium">{selectedExpense.invoice_no || ''}</span>
                                            </div>
                                            {/* <div className="d-flex justify-content-between">
                                                <span className="small text-muted">Entered By:</span>
                                                <span className="fw-medium">{selectedExpense.user || 'N/A'}</span>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>

                                {/* <div className="col-md-6">
                                    <div className="card border-0 shadow-sm mb-3">
                                        <div className="card-body">
                                            <h6 className="text-muted mb-2">Financial Details</h6>
                                            <div className="d-flex justify-content-between mb-2">
                                                <span className="small text-muted">Amount:</span>
                                                <span className="fw-medium">{formatCurrency(selectedExpense.amount_excl_vat)}
                                                                                                                              <span className="text-muted ms-1 font-size-11">
                                                                                                                                {selectedExpense.vendor_currency}

                                                </span>
                                                </span>
                                            </div>
                                            <div className="d-flex justify-content-between mb-2">
                                                <span className="small text-muted">VAT ({selectedExpense.vat_percent || 0}%):</span>
                                                <span className="text-success">{formatCurrency(selectedExpense.vat_amount || 0)}</span>
                                            </div>
                                            <div className="d-flex justify-content-between mb-2">
                                                <span className="small text-muted">Adjustment Amount:</span>
                                                <span className="text-success">{formatCurrency(selectedExpense.adjustment_amount || 0)}</span>
                                            </div>
                                            <div className="d-flex justify-content-between mb-2">
                                                <span className="small text-muted">Total:</span>
                                                <span className="fw-bold text-primary">{formatCurrency(selectedExpense.total)}
                                                                                                                            <span className="text-muted ms-1 font-size-11">
                                                                                                                                {selectedExpense.vendor_currency}

                                                </span>
                                                </span>
                                            </div>
                                            <div className="d-flex justify-content-between">
                                                <span className="small text-muted">Tax Type:</span>
                                                <span className={`badge ${selectedExpense.tax_type === 'taxable' ? 'bg-info' : 'bg-light text-dark'}`}>
                                                    {selectedExpense.tax_type || 'N/A'}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                            <div className="col-md-12">
                                <div className="card border-0 shadow-sm mb-3">
                                    <div className="card-body">
                                        <h6 className="text-muted mb-2">Financial Details (AED Conversion)</h6>
                                        <div className="d-flex justify-content-between mb-2">
                                            <span className="small text-muted">Amount (AED):</span>
                                            <span className="fw-medium text-primary">
                                                {formatCurrency(selectedExpense.amount_aed)} AED
                                            </span>
                                        </div>
                                        <div className="d-flex justify-content-between mb-2">
                                            <span className="small text-muted">VAT Amount (AED):</span>
                                            <span className="text-success">
                                                {formatCurrency(selectedExpense.vat_amount_aed || 0)} AED
                                            </span>
                                        </div>
                                        <div className="d-flex justify-content-between mb-2">
                                            <span className="small text-muted">Adjustment (AED):</span>
                                            <span className="text-success">
                                                {formatCurrency(selectedExpense.adjustment_amount_aed || 0)} AED
                                            </span>
                                        </div>
                                        <div className="d-flex justify-content-between mb-2">
                                            <span className="small text-muted">Total (AED):</span>
                                            <span className="fw-bold text-success">
                                                {formatCurrency(selectedExpense.total_aed)} AED
                                            </span>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <span className="small text-muted">Exchange Rate:</span>
                                            <span className="fw-medium">
                                                {selectedExpense.vendor_currency === 'USD' ? '1 USD = 3.692 AED' : '1:1 (AED)'}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Purchase Order Details */}
                            {selectedExpense.purchase_order && (
                                <div className="card border-0 shadow-sm mb-4">
                                    <div className="card-body">
                                        <h6 className="text-muted mb-3">
                                            <i className="mdi mdi-file-document-outline me-1"></i>
                                            Purchase Order
                                        </h6>
                                        <div className="d-flex justify-content-between mb-2">
                                            <span className="small text-muted">PO Ref:</span>
                                            <span
                                                className="fw-medium text-primary text-truncate"
                                                style={{ maxWidth: '150px' }}
                                                title={selectedExpense.purchase_order.ref_no}
                                            >
                                                {selectedExpense.purchase_order.ref_no}
                                            </span>
                                        </div>
                                        <div className="d-flex justify-content-between mb-2">
                                            <span className="small text-muted">Date:</span>
                                            <span className="fw-medium">
                                                {moment(selectedExpense.purchase_order.date).format('DD MMM YYYY')}
                                            </span>
                                        </div>
                                        <div className="d-flex justify-content-between mb-2">
                                            <span className="small text-muted">Amount:</span>
                                            <span className="fw-medium">{formatCurrency(selectedExpense.purchase_order.amount)}</span>
                                        </div>
                                        {/* <div className="d-flex justify-content-between">
                                            <span className="small text-muted">Status:</span>
                                            <span className="badge bg-info">{selectedExpense.purchase_order.status}</span>
                                        </div> */}
                                    </div>
                                </div>
                            )}

                            {/* Payment History */}
                            <div className="card border-0 shadow-sm mb-4">
                                <div className="card-body">
                                    <h6 className="text-muted mb-3">
                                        <i className="mdi mdi-history me-1"></i>
                                        Payment History
                                    </h6>

                                    <div className="d-flex justify-content-between mb-3 bg-light p-2 rounded">
                                        <div>
                                            <small className="text-muted d-block">Paid Amount</small>
                                            <span className="fw-bold text-success">{formatCurrency(selectedExpense.paid_amount || 0)}</span>
                                        </div>
                                        <div className="text-end">
                                            <small className="text-muted d-block">Balance</small>
                                            <span className="fw-bold text-danger">{formatCurrency(selectedExpense.balance_amount || 0)}</span>
                                        </div>
                                    </div>

                                    {selectedExpense.transactions && selectedExpense.transactions.length > 0 ? (
                                        <div className="payment-history-list">
                                            {selectedExpense.transactions.map((tx, idx) => (
                                                <div key={idx} className="p-3 bg-light rounded mb-3 border">
                                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                                        <span className="small fw-bold text-primary">Transaction</span>
                                                        <span className={`badge bg-opacity-10 ${tx.account_type?.toLowerCase().includes('bank') ? 'bg-white text-black' : 'bg-white text-success'}`}>
                                                            {tx.account_type?.toLowerCase().includes('bank') ? 'Bank' : 'Cash'}
                                                        </span>
                                                    </div>

                                                    <div className="d-flex justify-content-between mb-1">
                                                        <span className="small text-muted">Date:</span>
                                                        <span className="small fw-medium">{moment(tx.transaction_date).format('DD MMM YYYY')}</span>
                                                    </div>

                                                    <div className="d-flex justify-content-between mb-1">
                                                        <span className="small text-muted">Account:</span>
                                                        <span className="small fw-medium text-truncate" style={{ maxWidth: '180px' }} title={tx.account_name}>
                                                            {tx.account_name}
                                                        </span>
                                                    </div>

                                                    <div className="d-flex justify-content-between mb-1">
                                                        <span className="small text-muted">Ref No:</span>
                                                        <span className="small fw-medium text-truncate" style={{ maxWidth: '180px' }} title={tx.reference}>
                                                            {tx.reference}
                                                        </span>
                                                    </div>

                                                    <div className="d-flex justify-content-between pt-1 border-top mt-1">
                                                        <span className="small text-muted fw-bold">Paid amount:</span>
                                                        <span className="fw-bold text-success">{formatCurrency(tx.amount_paid)}</span>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <div className="text-center py-3 text-muted small">
                                            No payment transactions found
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Additional Information */}
                            {selectedExpense.notes && (
                                <div className="card border-0 shadow-sm">
                                    <div className="card-body">
                                        <h6 className="text-muted mb-2">Additional Notes</h6>
                                        <p className="mb-0">{selectedExpense.notes}</p>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </Offcanvas.Body>
            </Offcanvas>



        </div>
    );
};

export default ExpenseReport;
